<template>
  <div v-if="showMessage.show" class="content">
    <div class="container messageContainer">
      <div class="row my-5">
        <div class="col-12 d-flex justify-content-center">
          <img src="/web/minti-attention_new.png" class="attentionImg" alt="attention" />
        </div>
        <div v-for="(msg, i) in showMessage.message" class="col-12 mb-1" :key="'msg_' + i">
          <h4 class="text-center">
            {{ msg }}
          </h4>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="content">
    <div v-if="section !== 'schoolSelection'" class="floating-button">
      <button class="btn btn-success position-absolute rounded rounded-pill top-btn d-flex align-items-center px-3"
        @click.prevent="backToPreviousSection()">Zurück</button>
    </div>

    <div v-if="section === ''" class="align-items-center container d-flex h-100 justify-content-center">
      <div class="selection" @click="setSection('teacherLogin')">
        <img src="/images/account/teacher.png" class="card-img" alt="...">
        <!--div class="card-footer">
                    <h5 class="text-center mb-0 text-2xl">Lehrer</h5>
                </div-->
      </div>
      <div class="selection mx-3" @click="setSection('schoolSelection')">
        <img src="/images/account/student.png" class="card-img" alt="...">
        <!--div class="card-footer">
                    <h5 class="text-center mb-0 text-2xl">Schüler</h5>
                </div-->
      </div>
      <div class="selection d-none" @click="setSection('parentSection')">
        <img src="/images/account/parent.png" class="card-img" alt="...">
        <!--div class="card-footer">
                    <h5 class="text-center mb-0 text-2xl">Eltern</h5>
                </div-->
      </div>
    </div>

    <div v-if="section === 'teacherLogin'" class="align-items-center container d-flex h-100 justify-content-center">
      <login-form></login-form>
    </div>

    <div v-if="section === 'schoolSelection'">
      <div class="container mt-3">
        <div class="row my-2">
          <div class="col-10">
            <input class="form-control" type="text" v-model.trim="searchTxt" @keyup="filterSchool"
              placeholder="Okul Adı" />
          </div>
          <div class="col-2">
            <button class="btn btn-danger" @click="filterCancel">Sil</button>
          </div>
        </div>
        <div class="row my-2">
          <div style="height: 16rem;" v-for="sch in school.list" class="col-xs-12 col-md-4 col-lg-3 mb-5 cursor-pointer"
            :key="'keySchool_' + sch.id" @click="selectSchool(sch)">
            <div
              class="school-logo-for-selection d-flex h-100 w-100 br25 justify-content-center align-items-center hover:bg-success"
              :class="school.selected === sch ? 'bg-success' : ''">
              <img :src="sch.image + '?v=1'" alt="School" class="col-xs-12 col-md-4 col-lg-3 img-fluid">
            </div>
            <div class="row">
              <div class="col-12">
                <h6 class="text-center">{{ sch.name }}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="section === 'parentSection'"></div>

    <div v-if="section === 'studentActivation'" class="align-items-center container d-flex h-100 justify-content-center">
      <activation-form :html="student.values.html">
        <error :visible="student.form.has('info')" :errors="student.form.get('info')"></error>
        <form class="activation-form" @submit.prevent="submitStudentForm" @keydown="student.form.clear($event.target.id)">

          <div class="did-floating-label-content" v-if="school.selected.children">
            <select v-model="school.subSelected" class="did-floating-select"
              onclick="this.setAttribute('value', this.value);" onchange="this.setAttribute('value', this.value);"
              value="">
              <option value=""></option>
              <option v-for="child in getSchoolChildren" :key="'key_' + child" :value="child">{{ child.name }}</option>
            </select>
            <label class="did-floating-label">Şube Seçiniz</label>
          </div>
          <error :visible="student.form.has('sube')" :errors="student.form.get('sube')"></error>

          <div class="did-floating-label-content" v-if="(school.selected.children && school.subSelected !== '' && school.subSelected.personal_number_type !== 'tc') ||
            (school.selected.personal_number_type !== 'tc')
            ">
            <select v-model="school.classLevel" class="did-floating-select"
              onclick="this.setAttribute('value', this.value);" onchange="this.setAttribute('value', this.value);"
              value="">
              <option value=""></option>
              <template v-if="school.selected.children">
                <option v-for="classroom in school.subSelected.classrooms" :value="classroom"
                  :key="'clsKey_' + classroom">
                  {{ classroom }}</option>
              </template>
              <template v-else>
                <option v-for="classroom in school.selected.classrooms" :value="classroom" :key="'clsKey_' + classroom">
                  {{ classroom }}
                </option>
              </template>
            </select>
            <label class="did-floating-label">Sınıf Seviyesi Seçiniz</label>
          </div>

          <div class="floating-label">
            <input required type="text" id="personal_number" v-model="student.form.personal_number"
              :placeholder="student.values.personalNumber" oninput="this.value = this.value.toUpperCase()">
            <label for="personal_number" class="pl-2" v-text="student.values.personalNumber"></label>
          </div>
          <error :visible="student.form.has('personal_number')" :errors="student.form.get('personal_number')"></error>

          <div class="floating-label">
            <input required id="code" type="text" :placeholder="student.values.code" v-model="student.form.code"
              oninput="this.value = this.value.trim()">
            <label for="code" class="pl-2" v-text="student.values.code"></label>
          </div>
          <error :visible="student.form.has('code')" :errors="student.form.get('code')"></error>

          <div class="floating-label">
            <input required id="email" type="email" v-model="student.form.email" placeholder="E-Mail">
            <label for="email" class="pl-2">E-Mail</label>
          </div>
          <error :visible="student.form.has('email')" :errors="student.form.get('email')"></error>

          <div class="floating-label d-none">
            <input id="veli_email" type="email" v-model="student.form.veli_email" placeholder="Veli E-mail">
            <label for="email" class="pl-2">Veli E-Mail</label>
          </div>

          <div class="floating-label">
            <input id="phone" type="text" v-model="student.form.phone" placeholder="Telefon">
            <label for="email" class="pl-2">Telefon</label>
          </div>

          <div class="floating-label">
            <input required id="password" v-model="student.form.password" :type="student.form.passwordType"
              :placeholder="student.values.password">
            <label for="password" class="pl-2" v-text="student.values.password"></label>
            <div @click="student.form.togglePassword()" class="icon d-flex justify-content-center align-items-center">
              <span v-if="student.form.showPassword" class="fa fa-eye"></span>
              <span v-else class="fa fa-eye-slash"></span>
            </div>
          </div>
          <error :visible="student.form.has('password')" :errors="student.form.get('password')"></error>

          <div class="floating-label">
            <input required id="password_confirmation" :type="student.form.passwordType"
              v-model="student.form.password_confirmation" :placeholder="student.values.password_confirmation">
            <label for="password_confirmation" class="pl-2" v-text="student.values.password_confirmation"></label>
            <div @click="student.form.togglePassword()" class="icon d-flex justify-content-center align-items-center">
              <span v-if="student.form.showPassword" class="fa fa-eye"></span>
              <span v-else class="fa fa-eye-slash"></span>
            </div>
          </div>
          <error :visible="student.form.has('password_confirmation')" :errors="student.form.get('password_confirmation')">
          </error>
          <div class="d-block w-100 d-flex justify-content-start align-items-center flex-column flex-sm-row">
            <div @click="student.form.agreement = !student.form.agreement" id="checkbox-container" class="toggle-btn"
              :class="student.form.agreement ? 'active' : ''">
              <input id="checkbox" type="checkbox" class="cb-value" />
              <label for="checkbox" class="round-btn"></label>
            </div>
            <span class="font-weight-bold mb-3 mb-sm-0 cursor-pointer">
              <!-- TODO: Modal açma işlemi yapılacak! -->
              <a @click.prevent="modal('student', 'studentActivationAgreement', 'show')"
                class="float-left text-reset hover:underline">Üyelik sözleşmesini okuduğumu kabul ediyorum!</a>
            </span>
          </div>
          <div class="d-block w-100 d-flex justify-content-start align-items-center flex-column flex-sm-row">
            <div @click="student.form.iys = !student.form.iys" id="checkbox-container" class="toggle-btn"
              :class="student.form.iys ? 'active' : ''">
              <input id="checkbox" type="checkbox" class="cb-value" />
              <label for="checkbox" class="round-btn"></label>
            </div>
            <span class="font-weight-bold mb-3 mb-sm-0 cursor-pointer">
              <!-- TODO: Modal açma işlemi yapılacak! -->
              <a @click.prevent="modal('student', 'studentActivationIYS', 'show')"
                class="float-left text-reset hover:underline">İYS kapsamında Ticari Elektronik İleti gönderimini
                onaylıyorum.</a>
            </span>
          </div>
          <div class="d-block w-100 d-flex justify-content-start align-items-center flex-column flex-sm-row">
            <div id="kvkk-element" style="width:80px;height:40px;margin:10px;">
              <span> </span>
            </div>
            <span class="font-weight-bold mb-3 mb-sm-0 cursor-pointer">
              <a @click.prevent="modal('student', 'studentActivationKvkk', 'show')"
                class="float-left text-reset hover:underline">KVKK aydınlatma metnini okumak için tıklayınız.</a>
            </span>
          </div>
          <div class="d-flex justify-content-around w-100 flex-column flex-sm-row">

            <button @click.prevent="sendToLink('https://www.minticity.com')"
              class="btn btn-lg w-100 btn-info text-white mb-2 mb-sm-0 mr-sm-3" type="submit">
              {{ student.values.homePage }}
            </button>
            <button class="btn btn-lg w-100 bg-gradient-success text-white mb-2 mb-sm-0 mr-sm-3"
              :disabled="student.form.any() && !student.form.get('info')" type="submit">
              {{ student.values.submit }}
            </button>
            <!-- <button @click.prevent="sendToLink('/login')"
              class="btn btn-lg w-100 bg-gradient-success text-white mb-2 mb-sm-0 mr-sm-3"
              :disabled="student.form.any() && !student.form.get('info')" type="submit">
              Giriş Yap
            </button> -->
          </div>
        </form>
      </activation-form>
      <div class="modal" id="studentActivationAgreement" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <!--<div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>-->
            <div class="modal-body">
              <div>
                <p></p>
                <p class="MsoNormal"
                  style="text-align: center; line-height: normal; margin-bottom: .0001pt; background: white"
                  align="center"><b> <span style="font-size: 18.0pt; font-family: Verdana,sans-serif; color: black">
                      minticity.com ÜYELİK SÖZLEŞMESİ </span>
                  </b></p>
                <p class="MsoNormal"
                  style="text-align: center; line-height: normal; margin-bottom: .0001pt; background: white"
                  align="center"> <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"><b> <span
                      style="font-size: 13.5pt; font-family: Verdana,sans-serif; color: black"> 1. Taraflar</span></b>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">a)</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    www.minticity.com&nbsp;
                    internet sitesinin faaliyetlerini yürüten Şair Eşref Bulvarı,
                    1371 Sok. No:5 Alkan İşhanı Kat:4-5 adresinde mukim Özel Alman Dil Hizmetleri Eğitimi Tercüme Ticaret
                    Limited Şirketi (Bundan böyle “Minticity” veya “DAS AKADEMIE” olarak anılacaktır).</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"><b> <span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">b)</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Belirli bir dönem için www.minticity.com&nbsp;
                    internet sitesine üye olan internet kullanıcısı ("Üye").</span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"><b> <span
                      style="font-size: 13.5pt; font-family: Verdana,sans-serif; color: black"> 2. Sözleşmenin
                      Konusu</span></b>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> İşbu Sözleşme’ nin konusu
                    Minticity’ &nbsp;
                    nin sahip olduğu internet sitesi&nbsp;
                  </span><a target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                    href="http://www.hepsiburada.com/"><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    ‘ dan üyenin faydalanma şartlarının belirlenmesidir.</span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"><b> <span
                      style="font-size: 13.5pt; font-family: Verdana,sans-serif; color: black"> 3. Tarafların Hak ve
                      Yükümlülükleri</span></b>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.1.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Üye,
                    &nbsp;
                  </span><a target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                    href="http://www.hepsiburada.com/"><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    &nbsp;
                    internet sitesine üye olurken verdiği kişisel ve diğer sair bilgilerin kanunlar önünde doğru olduğunu,
                    Minticity' nin bu bilgilerin gerçeğe aykırılığı nedeniyle
                    uğrayacağı tüm zararları aynen ve derhal tazmin edeceğini kabul,
                    beyan ve taahhüt eder.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.2.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Üye,
                    Minticity ve/veya Eğitim görmekte olduğu okul tarafından kendisine bildirilen 9 aylık süre dahilinde
                    (her halukarda en fazla 1 yıl) geçerli olacak şekilde verilebilecek olan okul kodu,
                    kullanıcı numarası,
                    kullanıcı adı,
                    şifre,
                    aktivasyon kodu vb. hiçbir bilgiyi başka kişi ya da kuruluşlara veremez,
                    üyenin söz konusu bilgileri kullanma hakkı bizzat kendisine / velisine aittir. Bu sebeple doğabilecek
                    tüm sorumluluk ile üçüncü kişiler veya yetkili merciler tarafından Minticity' ye karşı ileri
                    sürülebilecek tüm iddia ve taleplere karşı,
                    Minticity' nin söz konusu izinsiz kullanımdan kaynaklanan her türlü tazminat ve
                    sair talep hakkı saklıdır.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.3.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Üye,
                    &nbsp;
                  </span><a target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                    href="http://www.hepsiburada.com/"><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    &nbsp;
                    internet sitesini kullanırken yasal mevzuat hükümlerine riayet etmeyi ve bunları ihlal etmemeyi baştan
                    kabul ve taahhüt eder. Aksi takdirde,
                    doğacak tüm hukuki ve cezai yükümlülükler tamamen ve münhasıran üyeyi bağlayacaktır.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.4.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Üye,
                    &nbsp;
                  </span><a target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                    href="http://www.hepsiburada.com/"><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    &nbsp;
                    internet sitesini hiçbir şekilde kamu düzenini bozucu,
                    genel ahlaka aykırı,
                    başkalarını rahatsız ve taciz edici şekilde,
                    yasalara aykırı bir amaç için,
                    başkalarının fikri ve telif haklarına tecavüz edecek şekilde kullanamaz. Ayrıca,
                    üye başkalarının hizmetleri kullanmasını önleyici veya zorlaştırıcı faaliyet (spam,
                    virüs,
                    truva atı,
                    vb.) ve işlemlerde bulunamaz. Aynı şekilde,
                    minticity.com içeriğindeki yarışma,
                    oyun vb. uygulamalara ilişkin özel bilgileri 3. şahıslarla paylaşamaz ve varsa program açıklarını
                    sisteme zarar verecek şekilde ifşa edemez.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.5.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span><a target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                    href="http://www.hepsiburada.com/"><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    &nbsp;
                    internet sitesinde üyeler tarafından beyan edilen,
                    yazılan,
                    kullanılan fikir ve düşünceler,
                    tamamen üyelerin kendi kişisel görüşleridir ve görüş sahibini bağlar. Bu görüş ve düşüncelerin
                    Minticity ile hiçbir ilgi ve bağlantısı yoktur. Minticity' nin üyenin beyan edeceği fikir ve görüşler
                    nedeniyle üçüncü kişilerin
                    uğrayabileceği zararlardan ve üçüncü kişilerin beyan edeceği fikir ve görüşler nedeniyle üyenin
                    uğrayabileceği zararlardan dolayı herhangi bir sorumluluğu bulunmamaktadır.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.6.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Minticity,
                    üye verilerinin yetkisiz kişilerce okunmasından ve üye yazılım ve verilerine gelebilecek zararlardan
                    dolayı sorumlu olmayacaktır. Üye,
                    &nbsp;
                  </span><a target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                    href="http://www.hepsiburada.com/"><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    &nbsp;
                    internet sitesinin kullanılmasından dolayı uğrayabileceği herhangi bir zarar yüzünden Minticity' den
                    tazminat talep etmemeyi peşinen kabul etmiştir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.7.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Üye,
                    diğer internet kullanıcılarının yazılımlarına ve verilerine izinsiz olarak ulaşmamayı veya bunları
                    kullanmamayı kabul etmiştir. Aksi takdirde,
                    bundan doğacak hukuki ve cezai sorumluluklar tamamen üyeye aittir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.8.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    İşbu üyelik sözleşmesi içerisinde sayılan maddelerden bir ya da birkaçını ihlal eden üye işbu ihlal
                    nedeniyle cezai ve hukuki olarak şahsen sorumlu olup,
                    Minticity’&nbsp;
                    yi bu ihlallerin hukuki ve cezai sonuçlarından ari tutacaktır. Ayrıca;
                    işbu ihlal nedeniyle,
                    olayın hukuk alanına intikal ettirilmesi halinde,
                    Minticity'
                    &nbsp;
                    nin üyeye karşı üyelik sözleşmesinde uyulmamasından dolayı tazminat talebinde bulunma hakkı
                    saklıdır.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.9.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Minticity'
                    nin her zaman tek taraflı olarak gerektiğinde üyenin üyeliğini silme,
                    üyeye ait dosya,
                    belge ve bilgileri silme hakkı vardır. Üye işbu tasarrufu önceden kabul eder. Bu durumda,
                    Minticity' nin hiçbir sorumluluğu yoktur.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.10.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span><a target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                    href="http://www.hepsiburada.com/"><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    &nbsp;
                    internet sitesi yazılım ve tasarımı Minticity mülkiyetinde olup,
                    bunlara ilişkin telif hakkı ve/veya diğer fikri mülkiyet hakları ilgili kanunlarca korunmakta olup,
                    bunlar&nbsp;
                    &nbsp;
                    üye tarafından izinsiz kullanılamaz,
                    iktisap edilemez ve değiştirilemez. Bu web sitesinde adı geçen başkaca şirketler ve ürünleri
                    sahiplerinin ticari markalarıdır ve ayrıca fikri mülkiyet hakları kapsamında korunmaktadır.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.11.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Minticity tarafından&nbsp;
                  </span><a target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                    href="http://www.hepsiburada.com/"><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    &nbsp;
                    internet sitesinin iyileştirilmesi,
                    geliştirilmesine yönelik olarak ve/veya yasal mevzuat çerçevesinde siteye erişmek için kullanılan
                    İnternet servis sağlayıcısının adı ve Internet Protokol (IP) adresi,
                    Siteye erişilen tarih ve saat,
                    sitede bulunulan sırada erişilen sayfalar ve siteye doğrudan bağlanılmasını sağlayan Web sitesinin
                    Internet adresi gibi birtakım bilgiler toplanabilir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.12.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Minticity kullanıcılarına daha iyi hizmet sunmak,
                    ürünlerini ve hizmetlerini iyileştirmek,
                    sitenin kullanımını kolaylaştırmak için kullanımını kullanıcılarının özel tercihlerine ve ilgi
                    alanlarına yönelik çalışmalarda üyelerin kişisel bilgilerini kullanabilir. Minticity,
                    üyenin&nbsp;
                  </span><a target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                    href="http://www.hepsiburada.com/"><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    &nbsp;
                    internet sitesi üzerinde yaptığı hareketlerin kaydını bulundurma hakkını saklı tutar.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.13.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    minticity.com’ a&nbsp;
                    üye olan kişi,
                    yürürlükte bulunan ve/veya yürürlüğe alınacak uygulamalar kapsamında Minticity ve iştiraki olan tüm
                    şirketler tarafından&nbsp;
                    kendisine ürün ve hizmet tanıtımları,
                    reklamlar,
                    kampanyalar,
                    avantajlar,
                    anketler &nbsp;
                    ve diğer müşteri memnuniyeti uygulamaları sunulmasına izin verdiğini beyan ve kabul eder. &nbsp;
                    Üye,
                    minticity.com’ a üye olurken ve/veya başka yollarla geçmişte vermiş olduğu ve/veya gelecekte vereceği
                    kişisel ve alışveriş bilgilerinin ve alışveriş ve/veya tüketici davranış bilgilerinin&nbsp;
                    yukarıdaki amaçlarla toplanmasına,
                    Minticity&nbsp;
                    iştiraki olan tüm şirketler ile paylaşılmasına,
                    Minticity ve iştiraki olan tüm şirketler tarafından kullanılmasına ve arşivlenmesine izin verdiğini
                    beyan ve kabul eder. Üye aksini bildirmediği sürece &nbsp;
                    üyeliği sona erdiğinde de &nbsp;
                    verilerin toplanmasına,
                    Minticity iştiraki olan tüm şirketler ile paylaşılmasına,
                    Minticity ve iştiraki olan tüm şirketler tarafından kullanılmasına ve arşivlenmesine izin verdiğini
                    beyan ve kabul eder. Üye aksini bildirmediği &nbsp;
                    sürece Minticity ve &nbsp;
                    iştiraki olan tüm şirketlerin&nbsp;
                    kendisi ile &nbsp;
                    internet,
                    telefon,
                    SMS,
                    &nbsp;
                    vb iletişim kanalları kullanarak irtibata geçmesine izin verdiğini beyan ve kabul eder. Üye yukarıda
                    bahsi geçen bilgilerin toplanması,
                    &nbsp;
                    paylaşılması,
                    kullanılması,
                    arşivlenmesi ve kendisine erişilmesi nedeniyle doğrudan ve/veya dolaylı maddi ve/veya manevi menfi
                    ve/veya müsbet,
                    velhasıl herhangi bir zarara uğradığı konusunda talepte bulunmayacağını ve Minticity ve iştiraki olan
                    şirketleri sorumlu tutmayacağını beyan ve kabul eder. Üye veri paylaşım tercihlerini değiştirmek
                    isterse,
                    bu talebini Minticity’ nin müşteri hizmetleri çağrı merkezlerine&nbsp;
                    iletebilir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.14.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Minticity,
                    üyenin kişisel bilgilerini yasal bir zorunluluk olarak istendiğinde veya (a) yasal gereklere uygun
                    hareket etmek veya Minticity’ ye tebliğ edilen yasal işlemlere uymak;
                    (b) Minticity ve Minticity web sitesi ailesinin haklarını ve mülkiyetini korumak ve savunmak için
                    gerekli olduğuna iyi niyetle kanaat getirdiği hallerde açıklayabilir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.15.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    minticity.com web sitesinin virüs ve benzeri amaçlı yazılımlardan arındırılmış olması için mevcut
                    imkanlar dahilinde tedbir alınmıştır. Bunun yanında nihai güvenliğin sağlanması için kullanıcının,
                    kendi virüs koruma sistemini tedarik etmesi ve gerekli korunmayı sağlaması gerekmektedir. Bu bağlamda
                    üye Minticity web sitesine girmesiyle,
                    kendi yazılım ve işletim sistemlerinde oluşabilecek tüm hata ve bunların doğrudan ya da dolaylı
                    sonuçlarından kendisinin sorumlu olduğunu kabul etmiş sayılır.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.16.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Minticity,
                    sitenin içeriğini dilediği zaman değiştirme,
                    kullanıcılara sağlanan herhangi bir hizmeti değiştirme ya da sona erdirme veya Minticity web sitesinde
                    kayıtlı kullanıcı bilgi ve verilerini silme hakkını saklı tutar.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.17.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Minticity,
                    üyelik sözleşmesinin koşullarını hiçbir şekil ve surette ön ihbara ve/veya ihtara gerek kalmaksızın
                    her zaman değiştirebilir,
                    güncelleyebilir veya iptal edebilir. Değiştirilen,
                    güncellenen ya da yürürlükten kaldırılan her hüküm,
                    yayın tarihinde tüm üyeler bakımından hüküm ifade edecektir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.18.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Taraflar,
                    Minticity' ye ait tüm bilgisayar kayıtlarının tek ve gerçek münhasır delil
                    olarak,
                    HMUK madde 287'ye uygun şekilde esas alınacağını ve söz konusu
                    kayıtların bir delil sözleşmesi teşkil ettiği hususunu kabul ve beyan eder.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.19.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Minticity,
                    iş bu üyelik sözleşmesi uyarınca,
                    üyelerinin kendisinde kayıtlı elektronik posta adreslerine bilgilendirme mailleri ve cep telefonlarına
                    bilgilendirme SMS’ leri gönderme yetkisine sahip olmakla beraber,
                    üye işbu üyelik sözleşmesini onaylamasıyla beraber bilgilendirme maillerinin elektronik posta adresine
                    ve bilgilendirme SMS’ lerinin cep telefonuna gönderilmesini kabul etmiş sayılacaktır. Üye mail ve/veya
                    SMS almaktan vazgeçmek istemesi durumunda Minticity müşteri hizmetlerine iptal isteğini bildirebilir.
                    Böylesi bir durumda söz konusu bildirimler kendisine gönderilmeyecektir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.20. </span></b>
                  <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> www.minticity.com
                    sitesine girilen bilgilerin ve işlemlerin güvenliği için gerekli önlemler,
                    bilgi ve işlemin mahiyetine Minticity ve/veya ilgili kart kuruluşlarınca sistem ve internet
                    altyapısında alınmıştır. Tüm kredi kartı işlemleri ve onayları tarafımızdan bağımsız olarak ilgili
                    banka ve benzeri kart kuruluşlarınca online olarak üye ile ilgili kuruluş arasında
                    gerçekleştirilmektedir (Kredi kartı şifresi gibi bilgiler Minticity tarafından görülmez ve
                    kaydedilmez). Üyelerin siteye üyelik,
                    ürün/hizmet satın alma ve bilgi güncelleme amaçlı girdikleri bilgiler,
                    özellikle kredi kartı ve banka kartlarına ait gizli bilgiler diğer internet kullanıcıları tarafından
                    görüntülenemez. Bu paragraf,
                    üyenin kredi kartı ile işlem yapacağı anlamına gelmemektedir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.21.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> Şayet site üzerinde böylesi
                    bir uygulama mevcut ise,
                    alışveriş yapan üyelerin özel istek ve talepleri uyarınca üretilen veya üzerinde değişiklik ya da
                    ilaveler yapılarak kişiye özel hale getirilen ya da niteliği itibariyle iade edilemeyecek,
                    hızla bozulma veya son kullanma tarihi geçme ihtimali olan bir ürün söz konusu olduğunda ve genel
                    olarak ürün kullanıldığında ya da kullanılmamış olsa dahi ambalajından çıkarıldığında Üye cayma
                    hakkını kullanamaz. Fikri eser olan ve kopyalanabilecek olan kitap vb. materyaller için iade söz
                    konusu değildir. İade hakları ile ilgili tüm hususlar Türkiye Cumhuriyeti Kanunları,
                    Yönetmelikleri vb. ile belirlenen koşullar dahilinde değerlendirilmektedir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.22. </span></b>
                  <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> Şayet site üzerinde
                    böylesi bir uygulama mevcut ise,
                    üyelerin satın aldıkları ürünler Minticity tarafından seçilen bir kargo firmasıyla gönderilecektir.
                    Kargo paketi üye tarafından kontrol edilip teslim alınmalı,
                    herhangi bir eksiklik ve/veya hasar vb. olumsuz bir durum varsa bu,
                    kargo personeli ile birlikte tutanak altına alınmalıdır. Aksi takdirde;
                    kargonun üyeye teslimi ile birlikte ürün üyenin kabul edilecek ve bununla birlikte tüm sorumluluk
                    kendisine ait olacaktır. Kargo ücreti ile ilgili hususlar online alışveriş sırasında üyeye
                    bildirileceği şekildedir. Minticity kısmen veya tamamen kargo ücretini alıp almamakta
                    serbesttir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.23.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> Şayet site üzerinde böylesi
                    bir uygulama mevcut ise,
                    Minticity,
                    üyenin satın aldığı tüm materyalleri sevkiyat tarihine kadar tedarik edememesi durumunda,
                    tedarik edemediği ürünün bedelini üyeye iade edecek ve diğer ürünleri gönderecektir. Üye kendisine
                    gönderilen ürünleri,
                    yine ürünlerle birlikte gönderilecek olan faturadan takip edebilir. O an için tedarik edilemeyen ürün
                    daha sonra bulunduğu takdirde,
                    üyeye bilgi verilecektir. Bu durumda üyenin talebi doğrultusunda işlem yapılacaktır.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"><b> <span
                      style="font-size: 13.5pt; font-family: Verdana,sans-serif; color: black"> 4. Diğer
                      Hususlar</span></b>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">Ek bilgi almak istediğiniz
                    konularda +90 232 445 10 08 numaralı DAS Akademie Müşteri Hizmetleri telefonumuzdan,
                  </span> <a style="color: blue; text-decoration: underline; text-underline: single"
                    href="mailto:info@das-akademie."> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif">
                      info@das-akademie.</span></a><span class="MsoHyperlink"><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif">de</span></span><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> eposta adresinden veya
                    www.minticity.com adresinden Minticity’ ye danışabilirsiniz.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> Site üzerinde işlem yapan
                    kişinin 18 yaşından küçük olması durumunda,
                    kendisine önceden üyelik giriş bilgileri iletilmiş olan velisi tüm işlemlerden sorumlu olacaktır.
                    Minticity sadece öğrenci velileri ile bilgi paylaşımı yapmaktadır. Velisi bulunduğu öğrencinin sistemi
                    yalnız başına kullanmasını istemeyen veliler,
                    şifre vb. izin verilen giriş bilgilerini kendilerine özel olarak değiştirerek,
                    siteye kendileri dışında girişi imkansız kılabilirler.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"><b> <span
                      style="font-size: 13.5pt; font-family: Verdana,sans-serif; color: black"> 5. Sözleşmenin Süresi ve
                      Feshi</span></b>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> İşbu sözleşme üyeye
                    bildirilen aktivasyon tarihinden itibaren,
                    9 aylık kullanım süresinin dolmasına (her halukarda en fazla 1 yıl) veya Minticity tarafından
                    üyeliğinin iptal edilmesine kadar yürürlükte kalacaktır. Minticity üyenin üyelik sözleşmesinin
                    herhangi bir hükmünü ihlal etmesi durumunda üyenin üyeliğini iptal ederek sözleşmeyi tek taraflı
                    olarak feshedebilecektir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"><b> <span
                      style="font-size: 13.5pt; font-family: Verdana,sans-serif; color: black"> 6. İhtilafların
                      Halli</span></b>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> İşbu sözleşmeye ilişkin
                    ihtilaflarda İZMİR Mahkemeleri ve İcra Daireleri yetkilidir.</span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"><b> <span
                      style="font-size: 13.5pt; font-family: Verdana,sans-serif; color: black"> 7. Yürürlük</span></b>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> Üyenin,
                    üyelik kaydı yapması üyenin üyelik sözleşmesinde yer alan tüm maddeleri okuduğu ve üyelik
                    sözleşmesinde yer alan maddeleri kabul ettiği anlamına gelir. İşbu Sözleşme üyenin üye olması anında
                    akdedilmiş ve karşılıklı olarak yürürlüğe girmiştir.</span>
                </p>
                <p class="MsoNormal">&nbsp;</p>
                <p class="MsoNormal" style="text-align: center; line-height: normal" align="center">
                  <b><i><span style="font-family: Verdana,sans-serif"> <a
                          style="color: blue; text-decoration: underline; text-underline: single"
                          href="http://www.minticity.com"> www.minticity.com</a></span></i></b>
                </p>
                <p class="MsoNormal" style="text-align: center; line-height: normal" align="center">
                  <b><span style="font-family: Verdana,sans-serif">Site Gizlilik Bildirimi (Privacy Policy)</span></b>
                </p>
                <p class="MsoNormal" style="text-align: center; line-height: normal" align="center">
                  <b><span style="font-family: Verdana,sans-serif">&nbsp;
                    </span></b>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">minticity.com “Minticity”,
                    gizliliğinizi korumak konusunda kararlıdır. Bu gizlilik bildirimi,
                    minticity.com site ve sitelerinin (“Site”) veri toplama ve kullanma uygulamalarını açıklar. Bu siteye
                    erişmeniz bu gizlilik bildiriminde tanımlanan,
                    bilgi toplama ve kullanma uygulamalarını kabul ediyor olduğunuzu gösterir.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Bu bildirimde ve aksi belirtilmedikçe,
                    Site üzerinde sağladığınız kişisel bilgiler izniniz olmaksızın minticity.com ve denetlediği yan
                    kuruluşları ve bağlı kuruluşları dışında paylaşılmayacaktır&nbsp;
                    (minticity.com bir Özel Alman Dil Hizmetleri Eğitimi Tercüme Ticaret Limited Şirketi
                    uygulamasıdır).</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <b><i>
                      <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Kişisel Bilgilerinizin
                        Toplanması</span></i></b>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <b><i>
                      <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                      </span></i></b>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Bu bilgileri,
                    minticity.com’ a kayıt olurken ya da minticity.com ürünleri ve hizmetleri hakkında bilgi alma,
                    yarışmalara katılma,
                    e-posta haber bültenleri sipariş etme,
                    erişim sınırlaması olan özel site veya hizmetlere katılma,
                    bir etkinlik veya eğitime kaydolma,
                    site üzerinden herhangi bir satın alma işleminde bulunma gibi talep ettiğiniz bir işlemi
                    gerçekleştirmenize veya size hizmet sağlamak için sizinle iletişim kurmamıza izin veren,
                    sizi kişi olarak tanıtan bilgilere (kişisel bilgiler) gerek duyduğumuz zaman sizden isteriz.
                    Topladığımız kişisel bilgiler arasında adınız,
                    unvanınız,
                    şirket veya kuruluşunuzun adı,
                    iş e-posta adresiniz,
                    iş telefonunuz,
                    iş veya ev adresiniz ve iş tanımınızla ile ilgili bilgiler olabilir.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Site,
                    ziyaretleriniz hakkında,
                    Siteye erişmek için kullandığınız Internet servis sağlayıcısının adı ve Internet Protokol (IP) adresi,
                    Siteye erişme tarihi ve saatiniz,
                    Sitede bulunduğunuz sırada eriştiğiniz sayfalar ve sitemize doğrudan bağlanmanızı sağlayan Web
                    sitesinin Internet adresi gibi birtakım bilgiler toplayabilir. Bu bilgiler sitenin iyileştirilmesi,
                    eğilimlerin analiz edilmesi ve Sitenin yönetilmesi için kullanılır.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Site kullanımı,
                    üyeleri,
                    ürünleri ve ilgili teknolojiler hakkındaki bilgileri ve haberleri paylaşmak üzere minticity.com
                    çalışanları,
                    uzmanları ve sizinle eş düzey kullanıcılarla iletişime girme olanakları sağlar. minticity.com,
                    e-posta adresinizin veya diğer kişisel bilgilerinizin başkaları tarafından toplanmasını,
                    uygunsuz veya zararlı amaçlar için kullanılmasını önlemek için,
                    gerçek e-posta adresinizi veya diğer kişisel bilgilerinizi,
                    yorumlar veya diğer genel forumlarda açıklamamaya dikkat etmeniz konusunda sizi uyarır.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <b><i>
                      <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Kişisel Bilgilerinizin
                        Kullanımı</span></i></b>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Sitede toplanan kişisel bilgiler,
                    Sitenin işletilmesi ve istediğiniz veya yetkilendirdiğiniz hizmetlerin sağlanması ya da işlemlerin
                    yerine getirilmesi için kullanılır.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">minticity.com bu kullanımları
                    desteklemek üzere,
                    müşterilerine daha etkili hizmet sunmak,
                    Siteyi ve diğer ilgili minticity.com ürünlerini veya hizmetlerini iyileştirmek ve aynı bilgileri
                    tekrar tekrar girme gereğini ortadan kaldırarak Sitenin kullanımını daha kolay hale getirmek veya
                    Siteyi özel tercihlerinize ve ilgi alanlarınıza göre özelleştirmek için kişisel bilgileri
                    kullanabilir. minticity.com ile ilişkilerinizin dengeli sürmesini sağlamak için,
                    minticity.com tarafından kullanılan bilgiler diğer minticity.com hizmetleri tarafından toplanan
                    bilgilerle birleştirilebilir.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Kişisel bilgilerinizi,
                    kritik güncelleştirmeleri ve bildirimleri de içerecek şekilde,
                    kullanmakta olduğunuz ürün veya hizmetler hakkında önemli bilgiler sağlamak için kullanabiliriz.
                    Ayrıca,
                    size diğer minticity.com ürünleri ve hizmetleri hakkında çeşitli yollarla bilgiler gönderebilir
                    ve/veya kendi ürünleri ve hizmetleri hakkında bilgi gönderebilmeleri için bu bilgileri diğer
                    minticity.com ortaklarıyla paylaşabiliriz.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Araştırma amacıyla,
                    site ziyaretleriyle ilgili verileri anonim demografik bilgilerle birleştiririz ve bu bilgileri daha
                    yararlı içerik sağlamak üzere toplu bir şekilde kullanabiliriz. minticity.com sitesinin giriş
                    sınırlaması olan kimi bölümlerinde,
                    kişiselleştirilmiş içerik sağlamak için,
                    sizden onay alarak site ziyaret verilerini kişisel bilgilerinizle birleştirebiliriz.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Site üyelik ve satın alma sözleşmesi
                    ile e-postalarını almayı kabul ettiğiniz minticity.com,
                    tıklattığınız e-postaları izlemek için özelleştirilmiş bağlantılar veya benzeri teknolojiler
                    kullanabilir. Size daha uygun e-postalar veya satış bilgileri gönderebilmek için bu bilgileri kişisel
                    bilgilerinizle ilişkilendirebiliriz. Her e-posta,
                    bu tür iletilerin gelmesini durdurmanıza olanak veren,
                    abonelik iptal bağlantıları içerir.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif"><br> Sitemizdeki kayıt formları,
                    anketler ve yarışmalar;
                    iletişim bilgilerinizi (adınız,
                    soyadınız,
                    email adresiniz,
                    telefon numaralarınız,
                    posta adresiniz,
                    vb.) ve kişisel bilgilerinizi (yaşınız,
                    mesleğiniz,
                    vb.) vermenizi talep edebilir. Minticity.com web sitelerini ziyaret eden kullanıcıların bilgileri
                    (ziyaret süresi,
                    zamanı,
                    görüntülenen sayfalar) onlara daha iyi hizmet edebilmek amacı ile takip edilmektedir. Elde edilen
                    bilgiler,
                    gizlilik prensiplerine bağlı kalmak kaydıyla,
                    içerik bölümümüzü zenginleştirmek ve iyileştirmek amacı ile anket,
                    reklam vb. konularda kullanılabilir. Bu işlemler sonucunda verdiğiniz iletişim bilgileri üzerinden
                    sizinle iletişime geçilmesini kabul etmiş olursunuz. minticity.com’ dan tarafınıza gönderilecek
                    e-Bülten ve/veya bilgilendirme e-maillerini almak istememeniz durumunda,
                    e-mail içeriğinde yer alan listeden çıkış isteği bağlantısına tıklanarak engellenebilir.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Minticity.com,
                    kişisel bilgilerinizi yasal bir zorunluluk olarak istendiğinde veya (a) yasal gereklere uygun hareket
                    etmek veya Minticity.com ya da Siteye tebliğ edilen yasal işlemlere uymak;
                    (b) Minticity.com ve Web sitesi ailemizin haklarını ve mülkiyetini korumak ve savunmak;
                    (c) Minticity.com çalışanlarının veya aracılarının,
                    Minticity.com ürünü kullananların veya kamu güvenliği açısından acil durumlarda harekete geçmek için
                    gerekli olduğuna iyi niyetle kanaat getirdiği hallerde açıklayabilir.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <b><i>
                      <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Kişisel Bilgilerinize
                        Erişim</span></i></b>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <b><i>
                      <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                      </span></i></b>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Bu Sitede sağladığınız kişisel bilgiler
                    ve bağlantı tercihlerinizi kendi sayfanızda inceleyebilir ve düzenleyebilirsiniz. Kişisel bilgileriniz
                    görüntülenmeden önce,
                    kullanıcı adı ve parolanızı girmeniz istenir.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">minticity.com üzerinde sunulan kimi
                    hizmetler Profil Merkezi' nden erişilemeyen bilgiler
                    toplayabilir. Ancak,
                    bu türden durumlarda kişisel bilgilerinize,
                    bu bildirimin sonunda açıklanan şekilde minticity.com ile bağlantı kurarak veya söz konusu hizmet
                    tarafından açıklanan başka yollarla erişebilirsiniz.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <b><i>
                      <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                      </span></i></b>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <b><i>
                      <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Kişisel Bilgilerinizin
                        Güvenliği</span></i></b>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">minticity.com,
                    kişisel bilgilerinizin güvenliğini korumayı ilke edinmiştir. Kişisel bilgilerinizi yetkisiz erişime,
                    kullanıma veya açığa çıkmaya karşı korumak için çok çeşitli güvenlik teknolojileri ve yordamları
                    kullanırız. Örneğin,
                    sağladığınız bilgileri kontrol altındaki tesislerde bulunan ve sınırlı erişimi olan bilgisayar
                    sunucularında depolarız.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Kredi kartı ile işlem yapıldığı
                    takdirde;
                    www.minticity.com sitesine girilen bilgilerin ve işlemlerin güvenliği için gerekli önlemler,
                    bilgi ve işlemin mahiyetine Minticity ve/veya ilgili kart kuruluşlarınca sistem ve internet
                    altyapısında alınmıştır. Tüm kredi kartı işlemleri ve onayları tarafımızdan bağımsız olarak ilgili
                    banka ve benzeri kart kuruluşlarınca online olarak üye ile ilgili kuruluş arasında
                    gerçekleştirilmektedir (Kredi kartı şifresi gibi bilgiler Minticity tarafından görülmez ve
                    kaydedilmez). Üyelerin siteye üyelik,
                    ürün/hizmet satın alma ve bilgi güncelleme amaçlı girdikleri bilgiler,
                    özellikle kredi kartı ve banka kartlarına ait gizli bilgiler diğer internet kullanıcıları tarafından
                    görüntülenemez.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <b><i>
                      <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Bu Gizlilik Bildiriminde
                        Yapılabilecek Değişiklikler</span></i></b>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <b><i>
                      <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                      </span></i></b>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Bu gizlilik bildirimini zaman zaman
                    güncelleştirebiliriz. Hizmeti kullanmanız bu gizlilik bildirimini ve yapılabilecek güncelleştirmeleri
                    kabul ettiğiniz anlamına gelir.</span>
                </p>
                <p class="MsoNormal" style="text-align:justify"> <span
                    style="font-size: 10.0pt; line-height: 115%; font-family: Verdana,sans-serif"> &nbsp;
                  </span>
                </p>
                <p></p>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-info text-white"
                @click="modal('student', 'studentActivationAgreement', 'hide')">Schließen
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal" id="studentActivationKvkk" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <h3 class="text-center">ÖZEL ALMAN DİL HİZ. EĞT. TER. TİC. LTD. ŞTİ. MINTICITY AYDINLATMA METNİ</h3>
              <ol type="a">
                <li>
                  <p align="justify"><span style="font-family: 'Times New Roman', serif;"><strong>Veri Sorumlusu
                      </strong></span></p>
                </li>
              </ol>
              <p align="justify"><span style="color: #000000;"> <span
                    style="font-family: 'Times New Roman', serif;"><strong>&Ouml;zel Alman Dil Hiz. Eğt. Ter. Tic. Ltd.
                      Şti. </strong></span></span><span style="font-family: 'Times New Roman', serif;">(Bundan sonra
                  &ldquo;Şirket&rdquo; olarak anılacaktır) olarak kişisel verilerinizi, 6698 sayılı Kişisel Verilerin
                  Korunması Kanunu (Bundan sonra </span><span
                  style="font-family: 'Times New Roman', serif;"><strong>&ldquo;KVKK&rdquo;</strong></span><span
                  style="font-family: 'Times New Roman', serif;"> olarak anılacaktır) ve ilgili sair mevzuat kapsamında,
                  veri sorumlusu sıfatı ile işlediğimizi tarafınıza bildiriyoruz.</span></p>
              <ol start="2" type="a">
                <li>
                  <p align="justify"><span style="font-family: 'Times New Roman', serif;"><strong>İşlenen Kişisel Veriler
                      </strong></span></p>
                </li>
              </ol>
              <p align="justify"><span style="font-family: 'Times New Roman', serif;">KVKK ve ilgili sair mevzuata uygun
                  olarak işbu </span><span style="font-family: 'Times New Roman', serif;"><u>Minticity Aydınlatma
                    Metni</u></span><span style="font-family: 'Times New Roman', serif;">&rsquo;nde belirtilen
                  ama&ccedil;lar ve hukuki sebepler kapsamında işlenecek kişisel veri kategori ve a&ccedil;ıklamaları
                  aşağıdaki gibidir:</span></p>
              <center>
                <table class="table">
                  <tbody>
                    <tr valign="top">
                      <td width="159" height="38">
                        <p><span style="font-family: 'Times New Roman', serif;"><span
                              style="font-size: small;"><strong>Kimlik Bilgileri</strong></span></span></p>
                      </td>
                      <td width="17">
                        <p align="justify"><span style="font-family: 'Times New Roman', serif;"><span
                              style="font-size: small;">:</span></span></p>
                      </td>
                      <td width="531">
                        <p align="justify"><span style="font-family: 'Times New Roman', serif;"><span
                              style="font-size: small;"><em>Adı-soyadı, cinsiyeti, TC kimlik numarası, okul
                                numarası</em></span></span></p>
                      </td>
                    </tr>
                    <tr valign="top">
                      <td width="159" height="17">
                        <p><span style="font-family: 'Times New Roman', serif;"><span
                              style="font-size: small;"><strong>İletişim Bilgileri</strong></span></span></p>
                      </td>
                      <td width="17">
                        <p align="justify"><span style="font-family: 'Times New Roman', serif;"><span
                              style="font-size: small;">:</span></span></p>
                      </td>
                      <td width="531">
                        <p align="justify"><span style="font-family: 'Times New Roman', serif;"><span
                              style="font-size: small;"><em>Okul adı, sınıf şubesi, e-posta adresi</em></span></span></p>
                        <p align="justify">&nbsp;</p>
                      </td>
                    </tr>
                    <tr valign="top">
                      <td width="159" height="11">
                        <p><span style="font-family: 'Times New Roman', serif;"><span
                              style="font-size: small;"><strong>&Ouml;zel Nitelikli kişisel </strong></span></span></p>
                        <p><span style="font-family: 'Times New Roman', serif;"><span
                              style="font-size: small;"><strong>Veriler</strong></span></span></p>
                      </td>
                      <td width="17">
                        <p align="justify"><span style="font-family: 'Times New Roman', serif;"><span
                              style="font-size: small;">:</span></span></p>
                      </td>
                      <td width="531">
                        <p align="justify">&nbsp;</p>
                      </td>
                    </tr>
                    <tr valign="top">
                      <td width="159" height="11">
                        <p><span style="font-family: 'Times New Roman', serif;"><span
                              style="font-size: small;"><strong>Diğer</strong></span></span></p>
                      </td>
                      <td width="17">
                        <p align="justify"><span style="font-family: 'Times New Roman', serif;"><span
                              style="font-size: small;">:</span></span></p>
                      </td>
                      <td width="531">
                        <p align="justify">&nbsp;</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </center>
              <ol start="3" type="a">
                <li>
                  <p align="justify"><span style="font-family: 'Times New Roman', serif;"><strong>Kişisel Verilerin Hangi
                        Ama&ccedil;la İşleneceği </strong></span></p>
                </li>
              </ol>
              <p align="justify"><span style="font-family: 'Times New Roman', serif;">Kişisel verileriniz, </span></p>
              <ul>
                <li>
                  <p><span style="font-family: 'Times New Roman', serif;">Minticity.com platformuna kayıt işleri sırasında
                      kullanılması, </span></p>
                </li>
                <li>
                  <p><span style="font-family: 'Times New Roman', serif;">&Uuml;yelik s&ouml;zleşmesi gereği mevzuattan
                      kaynaklanan y&uuml;k&uuml;ml&uuml;l&uuml;klerin yerine getirilmesi, </span></p>
                </li>
                <li>
                  <p><span style="font-family: 'Times New Roman', serif;">&Uuml;yelik s&ouml;zleşmesinin ifası sırasında
                      kullanılması, </span></p>
                </li>
                <li>
                  <p><span style="font-family: 'Times New Roman', serif;">İletişim faaliyetlerinin
                      y&uuml;r&uuml;t&uuml;lmesi,</span></p>
                </li>
                <li>
                  <p><span style="font-family: 'Times New Roman', serif;">Hukuk işlerinin takibi,</span></p>
                </li>
              </ul>
              <p align="justify"><span style="font-family: 'Times New Roman', serif;">ama&ccedil;larıyla KVKK&rsquo;nın 5
                  (2) maddesinde belirtilen </span><span style="font-family: 'Times New Roman', serif;"><em>&ldquo;a)
                    Kanunlarda a&ccedil;ık&ccedil;a &ouml;ng&ouml;r&uuml;lmesi&rdquo;, &ldquo;c) Bir s&ouml;zleşmenin
                    kurulması veya ifasıyla doğrudan doğruya ilgili olması kaydıyla, s&ouml;zleşmenin taraflarına ait
                    kişisel verilerin işlenmesinin gerekli olması&rdquo;, &ldquo;&ccedil;) Veri sorumlusunun hukuki
                    y&uuml;k&uuml;ml&uuml;l&uuml;ğ&uuml;n&uuml;n yerine getirebilmesi i&ccedil;in zorunlu olması, e) Bir
                    hakkın tesisi, kullanılması veya korunması i&ccedil;in veri işlemenin zorunlu olması&rdquo;
                  </em></span><span style="font-family: 'Times New Roman', serif;">hukuki sebepleri d&acirc;hilinde
                  işlenecektir. </span></p>
              <ol start="4" type="a">
                <li>
                  <p align="justify"><span style="font-family: 'Times New Roman', serif;"><strong>Kişisel Verilerin
                        Toplama Y&ouml;ntemi ve Hukuki Sebebi </strong></span></p>
                </li>
              </ol>
              <p align="justify"><span style="font-family: 'Times New Roman', serif;">Kişisel verileriniz, bu metnin (c)
                  fıkrasındaki ama&ccedil;ların yerine getirilebilmesi i&ccedil;in KVKK&rsquo;nın 5 (2) ve 6 (3)
                  maddelerinde d&uuml;zenlenen hukuki sebeplere dayanarak, aşağıda belirtilen otomatik veya otomatik
                  olmayan y&ouml;ntemlerle s&ouml;zl&uuml;, yazılı veya elektronik ortamlarda elde edilecektir: </span>
              </p>
              <ul>
                <li>
                  <p><span style="font-family: 'Times New Roman', serif;">Platform i&ccedil;in kayıt yapıldığı sırada
                      işlenmesi, </span></p>
                </li>
                <li>
                  <p><span style="font-family: 'Times New Roman', serif;">Fiziki ve elektronik ortamda işlenmesi, </span>
                  </p>
                </li>
              </ul>
              <ol start="5" type="a">
                <li>
                  <p align="justify"><span style="font-family: 'Times New Roman', serif;"><strong>İşlenen Kişisel
                        Verilerin Kimlere ve Hangi Ama&ccedil;la Aktarılabileceği </strong></span></p>
                </li>
              </ol>
              <p align="justify"><span style="font-family: 'Times New Roman', serif;">Kişisel verileriniz, aşağıda
                  belirtilen ama&ccedil;lar ile KVKK&rsquo;nın 8 (2) (a) maddeleri uyarınca Minticity kullanıcısının
                  (yasal velisinin) a&ccedil;ık rızası aranmaksızın aktarılacaktır: </span></p>
              <ul>
                <li>
                  <p align="justify"><span style="color: #000000;"><span
                        style="font-family: 'Times New Roman', serif;">Platforma kayıt sırasında elektronik veya fiziki
                        ortamda aktarılabilecektir. </span></span></p>
                </li>
              </ul>
              <ol start="6" type="a">
                <li>
                  <p align="justify"><span style="font-family: 'Times New Roman', serif;"><strong>Yurtdışına Aktarım
                      </strong></span></p>
                </li>
              </ol>
              <p align="justify"><span style="font-family: 'Times New Roman', serif;">KVKK&rsquo;nın 5 (2) maddesinde
                  belirtilen hukuki sebeplere dayanarak işlenen kişisel verileriniz, bordrolamaya ilişkin işlemlerin veri
                  tabanları yurt dışında olan &ccedil;evrimi&ccedil;i yazılım sistemleri aracılığıyla
                  ger&ccedil;ekleştirilmesi nedeniyle, KVKK&rsquo;nın 9 (2) maddesindeki yurt dışına aktarım şartları
                  doğrultusunda, ilgili kişinin a&ccedil;ık rızası temin edilmeksizin, </span></p>
              <ol type="i">
                <li>
                  <p align="justify"><span style="font-family: 'Times New Roman', serif;">Kişisel Verileri Koruma Kurulu
                      (Bundan sonra </span><span
                      style="font-family: 'Times New Roman', serif;"><strong>&ldquo;Kurul&rdquo;</strong></span><span
                      style="font-family: 'Times New Roman', serif;"> olarak anılacaktır.) tarafından yeterli korumaya
                      sahip olduğu ilan edilen yabancı &uuml;lkelere </span><span
                      style="font-family: 'Times New Roman', serif;"><strong>(&ldquo;Yeterli Korumaya Sahip Yabancı
                        &Uuml;lke&rdquo;)</strong></span><span style="font-family: 'Times New Roman', serif;"> veya
                    </span></p>
                </li>
                <li>
                  <p align="justify"><span style="font-family: 'Times New Roman', serif;">T&uuml;rkiye&rsquo;deki ve
                      ilgili yabancı &uuml;lkedeki veri sorumlularının yeterli bir korumayı yazılı olarak taahh&uuml;t
                      ettiği ve ilgili aktarım a&ccedil;ısından Kurul&rsquo;un izninin bulunduğu yabancı &uuml;lke ve/veya
                      &uuml;lkeler </span><span style="font-family: 'Times New Roman', serif;"><strong>(&ldquo;Yeterli
                        Korumayı Taahh&uuml;t Eden Veri Sorumlusunun Bulunduğu Yabancı &Uuml;lke&rdquo;)
                      </strong></span><span style="font-family: 'Times New Roman', serif;">ile sınırlı olmak
                      kaydıyla</span></p>
                </li>
              </ol>
              <p align="justify"><span style="font-family: 'Times New Roman', serif;">aktarılabilecektir.</span></p>
              <p align="justify"><a name="_GoBack"></a> <span style="font-family: 'Times New Roman', serif;">Yukarıda
                  a&ccedil;ıklanan ama&ccedil;lar kapsamında işlenen kişisel verilerinizin yurt dışına aktarımı, KVKK ve
                  ilgili sair mevzuat başta olmak &uuml;zere, Kurul tarafından alınan kararlar ve ilgili
                  d&uuml;zenlemelere uygun olarak, Şirketimiz tarafından gerekli &ouml;zen g&ouml;sterilerek ve gerekli
                  t&uuml;m g&uuml;venlik &ouml;nlemler alınarak ger&ccedil;ekleştirilecektir. </span></p>
              <ol start="7" type="a">
                <li>
                  <p align="justify"><span style="font-family: 'Times New Roman', serif;"><strong>KVKK&rsquo;nın 11.
                        Maddesi Kapsamındaki Haklarınız </strong></span></p>
                </li>
              </ol>
              <p align="justify"><span style="font-family: 'Times New Roman', serif;">KVKK&rsquo;nın 11. maddesi
                  kapsamında, veri sahibi olarak</span> <span style="font-family: 'Times New Roman', serif;">haklarınız
                  bulunmakta olup bu haklarınız ile ilgili taleplerinizi tercihen web sitemizde yer alan </span><span
                  style="font-family: 'Times New Roman', serif;"><u>İlgili Kişi Başvuru Formu</u></span><span
                  style="font-family: 'Times New Roman', serif;">&rsquo;nda belirtilen b&uuml;t&uuml;n bilgileri doldurmak
                  suretiyle KVKK&rsquo;nın 11. maddesi ile 13. maddesinin 1. fıkrası ve </span><span
                  style="font-family: 'Times New Roman', serif;"><em><strong>Veri Sorumlusuna Başvuru Usul ve Esasları
                      Hakkında Tebliğ</strong></em></span><span style="font-family: 'Times New Roman', serif;"> gereğince,
                </span></p>
              <ul>
                <li>
                  <p align="justify">&lsquo;&rsquo;<span style="font-family: 'Times New Roman', serif;"><em>İsmet Kaptan
                        Mah. 1371 Sok. No.5 Kat:4-5 &Ccedil;ankaya/İzmir &rdquo; </em></span><span
                      style="font-family: 'Times New Roman', serif;">adresindeki Şirketimize bizzat gelerek,</span></p>
                </li>
                <li>
                  <p align="justify"><span style="font-family: Calibri, serif;">ozelalmandilhizmetleri@hs01.kep.tr
                    </span><span style="font-family: 'Times New Roman', serif;">şeklindeki kayıtlı elektronik posta (KEP)
                      adresimiz &uuml;zerinden,</span></p>
                </li>
              </ul>
              <ul>
                <li>
                  <p align="justify"><span style="font-family: 'Times New Roman', serif;">kimliğinizi tespit edebilmek ve
                      yanlış kişilere bilgi vermemek adına yazılı olarak noter aracılığı ile veya iadeli
                      taahh&uuml;tl&uuml; mektup ile,</span></p>
                </li>
                <li>
                  <p align="justify"><span style="font-family: 'Times New Roman', serif;">g&uuml;venli elektronik imza,
                      mobil imza ya da (varsa) tarafınızca daha Şirketimize bildirilen ve sistemlerimizde kayıtlı bulunan
                      elektronik posta adresini kullanmak suretiyle </span><span style="color: #0563c1;"><u><a
                          href="mailto:kvkk@das-akademie.de"><span
                            style="font-family: Calibri, serif;">kvkk@das-akademie.de</span></a></u></span> <span
                      style="font-family: 'Times New Roman', serif;">adresine elektronik posta g&ouml;ndererek
                    </span><span style="font-family: 'Times New Roman', serif;">veya gelecekte Kurul&rsquo;un
                      belirleyeceği diğer y&ouml;ntemlerle iletebilirsiniz. </span></p>
                </li>
              </ul>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p style="text-align: right;">Okudum, anladım. _______________</p>
            </div>
            <div class="modal-footer">
              <button class="btn btn-info text-white" @click="modal('student', 'studentActivationKvkk', 'hide')">Schließen
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal" id="studentActivationIYS" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <h2 style="text-align:start"><strong><span style="font-size:11pt"><span
                      style="font-family:Calibri,sans-serif"><span style="color:#000000">TİCARİ ELEKTRONİK İLETİ
                        G&Ouml;NDERİMİ HAKKINDA BİLGİLENDİRME</span></span></span></strong></h2>

              <p style="text-align:start"><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif"><span
                      style="color:#000000">6563 sayılı Elektronik Ticaretin D&uuml;zenlenmesi Hakkında Kanun ve ilgili
                      mevzuat uyarınca ticari elektronik ileti; telefon, &ccedil;ağrı merkezleri, faks, otomatik arama
                      makineleri, akıllı ses kaydedici sistemler, elektronik posta, kısa mesaj hizmeti gibi vasıtalar
                      kullanılarak elektronik ortamda ger&ccedil;ekleştirilen ve ticari ama&ccedil;larla g&ouml;nderilen
                      veri, ses ve g&ouml;r&uuml;nt&uuml; i&ccedil;erikli iletileri ifade eder.</span></span></span></p>

              <p style="text-align:start"><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif"><span
                      style="color:#000000">Ticari elektronik iletiler, alıcılara ancak &ouml;nceden onayları alınmak
                      kaydıyla g&ouml;nderilebilir. Ticari Elektronik İleti Y&ouml;netim Sistemi (&ldquo;İYS&rdquo;)
                      &uuml;zerinde onayı bulunmayan alıcılara ticari elektronik ileti g&ouml;nderilemez Bu onay, yazılı
                      olarak veya her t&uuml;rl&uuml; elektronik iletişim ara&ccedil;larıyla ya da İYS (sistemin kullanıma
                      a&ccedil;ılması halinde) &uuml;zerinden alınabilir. İYS &uuml;zerinden alınan onaylarda ise olumlu
                      irade beyanı ve elektronik iletişim adresi yer alır. Alıcılar diledikleri zaman, hi&ccedil;bir
                      gerek&ccedil;e belirtmeksizin ticari elektronik iletileri almayı reddedebilir. Alıcının ret
                      bildiriminde bulunması, bildirimin yapıldığı iletişim kanalına ilişkin onayı ge&ccedil;ersiz kılar.
                      Alıcı reddetme hakkını İYS (sistemin kullanıma a&ccedil;ılması halinde) &uuml;zerinden de
                      kullanabilir.</span></span></span></p>

              <p style="text-align:start"><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif"><span
                      style="color:#000000">Alıcının kendisiyle iletişime ge&ccedil;ilmesi amacıyla iletişim bilgilerini
                      vermesi h&acirc;linde, temin edilen mal veya hizmetlere ilişkin değişiklik, kullanım ve bakıma
                      y&ouml;nelik ticari elektronik iletiler i&ccedil;in ayrıca onay alınmaz.</span></span></span></p>

              <p style="text-align:start"><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif"><span
                      style="color:#000000">Tacir veya esnaf olan alıcıların elektronik iletişim adreslerine
                      g&ouml;nderilen ticari elektronik iletiler i&ccedil;in &ouml;nceden onay alınması zorunlu değildir.
                      Ancak tacir ve esnafların ilgili mevzuatta yer alan reddetme hakkını kullanması halinde onayları
                      alınmadan ticari elektronik ileti g&ouml;nderilemez. Bu kapsamında ileti g&ouml;nderilmesinden
                      &ouml;nce tacir veya esnaf olan alıcıların elektronik iletişim adresleri hizmet sağlayıcı tarafından
                      İYS&rsquo;ye kaydedilir ve İYS &uuml;zerinden alıcıların ret hakkını kullanıp kullanmadığı kontrol
                      edilir.</span></span></span></p>

              <p style="text-align:start"><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif"><span
                      style="color:#000000">6563 sayılı Elektronik Ticaretin D&uuml;zenlenmesi Hakkında Kanun ve ilgili
                      mevzuat uyarınca, Minticity (&Ouml;zel Alman Dil Hiz. Eğt. Ter. Tic. Ltd. Şti.) tarafından vermekte
                      olduğumuz hizmetler kapsamında, Minticity websitesi &uuml;zerinden temin edilen bilgileriniz
                      doğrultusunda, onay vermeniz halinde herhangi bir iletişim aracı kullanarak (SMS, e-posta, telefon,
                      faks, &ccedil;ağrı merkezi, v.b. gibi) tarafınıza her t&uuml;rl&uuml; bilgilendirme, tanıtım,
                      reklam, &uuml;r&uuml;n teklifleri, promosyonlar, kampanyalar, memnuniyet değerlendirme
                      &ccedil;alışmaları ve duyuruların iletilmesi amacıyla tarafınızla iletişime
                      ge&ccedil;ilebilecektir.</span></span></span></p>

              <p style="text-align:start"><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif"><span
                      style="color:#000000">6563 sayılı Elektronik Ticaretin D&uuml;zenlenmesi Hakkında Kanun ve ilgili
                      mevzuat uyarınca ticari elektronik ileti g&ouml;nderimine dair onay verseniz dahi dilediğiniz zaman,
                      hi&ccedil;bir gerek&ccedil;e belirtmeksizin ticari elektronik iletileri almayı reddedebilirsiniz.
                      Ticari elektronik ileti hangi iletişim kanalıyla g&ouml;nderildiyse ret bildirimi de kolay ve
                      &uuml;cretsiz bir şekilde olmak &uuml;zere aynı iletişim kanalıyla verebileceğinizi hatırlatmak
                      isteriz. Reddetme hakkınızı İYS (sistemin kullanıma a&ccedil;ılması halinde) &uuml;zerinden de
                      kullanabilirsiniz.</span></span></span></p>

              <p style="text-align:start">&nbsp;</p>

              <p style="text-align:start"><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif"><span
                      style="color:#000000">TİCARİ ELEKTRONİK İLETİ G&Ouml;NDERİMİ RIZA BEYANI</span></span></span></p>

              <p style="text-align:start"><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif"><span
                      style="color:#000000">İşbu beyanı onaylayarak, Minticity&#39;nin, 6563 sayılı Elektronik Ticaretin
                      D&uuml;zenlenmesi Hakkında Kanun ve ilgili mevzuat uyarınca, Minticity tarafından tarafıma
                      verilmekte olan hizmetler kapsamında, Minticity Websitesi&rsquo;ne sağladığım ad, soyad ve iletişim
                      bilgilerim vasıtasıyla, herhangi bir iletişim aracı kullanarak (SMS, e-posta, telefon, faks,
                      &ccedil;ağrı merkezi, v.b. gibi) tarafıma her t&uuml;rl&uuml; bilgilendirme, tanıtım, reklam,
                      &uuml;r&uuml;n teklifleri, promosyonlar, kampanyalar, memnuniyet değerlendirme &ccedil;alışmaları ve
                      duyuruların iletilmesi amacıyla tarafımla iletişime ge&ccedil;ilmesine a&ccedil;ık rıza verdiğimi,
                    </span></span></span></p>

              <p style="text-align:start">&nbsp;</p>

              <p style="text-align:start"><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif"><span
                      style="color:#000000">Tarafımca verilmiş işbu rızanın geri alınabilir olduğu konusunda bilgim
                      olduğunu ve bu doğrultuda Minticity&rsquo;ye, ticari elektronik ileti hangi iletişim kanalıyla
                      g&ouml;nderildiyse ret bildirimi de kolay ve &uuml;cretsiz bir şekilde olmak &uuml;zere aynı
                      iletişim kanalıyla verebileceğimi, reddetme hakkımı İYS (sistemin kullanıma a&ccedil;ılması halinde)
                      &uuml;zerinden de kullanabileceğimi bildiğimi kabul, beyan ve taahh&uuml;t
                      ederim.</span></span></span></p>

            </div>
            <div class="modal-footer">
              <button class="btn btn-info text-white" @click="modal('student', 'studentActivationKvkk', 'hide')">Schließen
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="section === 'parentCreate'" class="align-items-center container d-flex h-100 justify-content-center">
      <activation-form :html="parent.values.html">
        <error :visible="parent.form.has('info')" :errors="parent.form.get('info')"></error>
        <form class="activation-form" @submit.prevent="parent.form.post('/')"
          @keydown="parent.form.clear($event.target.id)">
          <div class="floating-label">
            <input required type="text" maxlength="11" id="personal_number" v-model="parent.form.personal_number"
              :placeholder="parent.values.personalNumber" oninput="this.value = this.value.trim().replace(/[^0-9]/g,'')">
            <label for="personal_number" class="pl-2" v-text="parent.values.personalNumber"></label>
          </div>
          <error :visible="student.form.has('personal_number')" :errors="student.form.get('personal_number')"></error>

          <div class="floating-label">
            <input required type="text" id="name_surname" v-model="parent.form.name_surname"
              :placeholder="parent.values.name_surname">
            <label for="name_surname" class="pl-2" v-text="parent.values.name_surname"></label>
          </div>
          <error :visible="student.form.has('name_surname')" :errors="student.form.get('name_surname')"></error>

          <div class="floating-label">
            <input required id="email" type="email" v-model="parent.form.email" :placeholder="parent.values.email">
            <label for="email" class="pl-2" v-text="parent.values.email"></label>
          </div>
          <error :visible="parent.form.has('email')" :errors="parent.form.get('email')"></error>

          <div class="floating-label">
            <input required id="password" v-model="parent.form.password" :type="parent.form.passwordType"
              :placeholder="parent.values.password">
            <label for="password" class="pl-2" v-text="parent.values.password"></label>
            <div @click="parent.form.togglePassword()" class="icon d-flex justify-content-center align-items-center">
              <span v-if="parent.form.showPassword" class="fa fa-eye"></span>
              <span v-else class="fa fa-eye-slash"></span>
            </div>
          </div>
          <error :visible="parent.form.has('password')" :errors="parent.form.get('password')"></error>

          <div class="floating-label">
            <input required id="password_confirmation" :type="parent.form.passwordType"
              v-model="parent.form.password_confirmation" :placeholder="parent.values.password_confirmation">
            <label for="password_confirmation" class="pl-2" v-text="parent.values.password_confirmation"></label>
            <div @click="parent.form.togglePassword()" class="icon d-flex justify-content-center align-items-center">
              <span v-if="parent.form.showPassword" class="fa fa-eye"></span>
              <span v-else class="fa fa-eye-slash"></span>
            </div>
          </div>
          <error :visible="parent.form.has('password_confirmation')" :errors="parent.form.get('password_confirmation')">
          </error>


          <div class="d-block w-100 d-flex justify-content-start align-items-center flex-column flex-sm-row">
            <div @click="parent.form.agreement = !parent.form.agreement" id="checkbox-container" class="toggle-btn"
              :class="parent.form.agreement ? 'active' : ''">
              <input id="checkbox" type="checkbox" class="cb-value" />
              <label for="checkbox" class="round-btn"></label>
            </div>

            <span class="font-weight-bold mb-3 mb-sm-0 cursor-pointer">
              <!-- TODO: Modal açma işlemi yapılacak! -->
              <a @click.prevent="modal('parent', 'parentActivationAgreement', 'show')"
                class="float-left text-reset hover:underline">
                Üyelik sözleşmesini okuduğumu kabul ediyorum!
              </a>
            </span>
          </div>

          <div class="d-flex justify-content-around w-100 flex-column flex-sm-row">
            <button @click.prevent="sendToLink('/')" class="btn btn-lg w-100 btn-info text-white mb-2 mb-sm-0 mr-sm-3"
              type="submit">
              {{ parent.values.homePage }}
            </button>
            <button class="btn btn-lg w-100 bg-gradient-success text-white mb-2 mb-sm-0 mr-sm-3"
              :disabled="parent.form.any() && !parent.form.get('info')" type="submit">
              {{ parent.values.submit }}
            </button>
            <!-- <button @click.prevent="sendToLink('/login')" class="btn btn-lg w-100 bg-gradient-success text-white mr-sm-3"
              :disabled="parent.form.any() && !parent.form.get('info')" type="submit">

              Giriş Yap
            </button> -->
          </div>
        </form>
      </activation-form>

      <div class="modal" id="parentActivationAgreement" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <!--<div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>-->
            <div class="modal-body">
              <div class="md-content col-md-12">
                <div>
                  <p></p>
                  <p class="MsoNormal"
                    style="text-align: center; line-height: normal; margin-bottom: .0001pt; background: white"
                    align="center">
                    <b><span style="font-size: 18.0pt; font-family: Verdana,sans-serif; color: black">minticity.com ÜYELİK
                        SÖZLEŞMESİ</span></b>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: center; line-height: normal; margin-bottom: .0001pt; background: white"
                    align="center">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 13.5pt; font-family: Verdana,sans-serif; color: black">
                        1. Taraflar</span></b>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">a)</span></b><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;www.minticity.com&nbsp;internet
                      sitesinin faaliyetlerini yürüten Şair Eşref Bulvarı, 1371 Sok. No:5 Alkan İşhanı
                      Kat:4-5 adresinde mukim Özel Alman Dil Hizmetleri Eğitimi Tercüme Ticaret
                      Limited Şirketi (Bundan böyle “Minticity” veya “DAS AKADEMIE” olarak
                      anılacaktır).</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">b)</span></b><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;Belirli
                      bir dönem için www.minticity.com&nbsp;internet sitesine üye olan internet kullanıcısı
                      ("Üye").</span>
                  </p>
                  <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 13.5pt; font-family: Verdana,sans-serif; color: black">
                        2. Sözleşmenin Konusu</span></b>
                  </p>
                  <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                      İşbu Sözleşme’ nin konusu Minticity’ &nbsp;nin sahip olduğu internet sitesi&nbsp;</span><a
                      target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                      href="http://www.hepsiburada.com/"><span
                        style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;‘
                      dan üyenin faydalanma şartlarının belirlenmesidir.</span>
                  </p>
                  <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 13.5pt; font-family: Verdana,sans-serif; color: black">
                        3. Tarafların Hak ve Yükümlülükleri</span></b>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.1.</span></b><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;Üye,&nbsp;</span><a
                      target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                      href="http://www.hepsiburada.com/"><span
                        style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;&nbsp;internet
                      sitesine üye olurken verdiği kişisel ve diğer sair bilgilerin kanunlar önünde
                      doğru olduğunu, Minticity' nin bu bilgilerin gerçeğe aykırılığı nedeniyle
                      uğrayacağı tüm zararları aynen ve derhal tazmin edeceğini kabul, beyan ve
                      taahhüt eder.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.2.</span></b><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;Üye,
                      Minticity ve/veya Eğitim görmekte olduğu okul tarafından kendisine bildirilen 9
                      aylık süre dahilinde (her halukarda en fazla 1 yıl) geçerli olacak şekilde
                      verilebilecek olan okul kodu, kullanıcı numarası, kullanıcı adı, şifre,
                      aktivasyon kodu vb. hiçbir bilgiyi başka kişi ya da kuruluşlara veremez, üyenin
                      söz konusu bilgileri kullanma hakkı bizzat kendisine / velisine aittir. Bu
                      sebeple doğabilecek tüm sorumluluk ile üçüncü kişiler veya yetkili merciler
                      tarafından Minticity' ye karşı ileri sürülebilecek tüm iddia ve taleplere karşı,
                      Minticity' nin söz konusu izinsiz kullanımdan kaynaklanan her türlü tazminat ve
                      sair talep hakkı saklıdır.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.3.</span></b><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;Üye,&nbsp;</span><a
                      target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                      href="http://www.hepsiburada.com/"><span
                        style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;&nbsp;internet
                      sitesini kullanırken yasal mevzuat hükümlerine riayet etmeyi ve bunları ihlal
                      etmemeyi baştan kabul ve taahhüt eder. Aksi takdirde, doğacak tüm hukuki ve
                      cezai yükümlülükler tamamen ve münhasıran üyeyi bağlayacaktır.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.4.</span></b><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;Üye,&nbsp;</span><a
                      target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                      href="http://www.hepsiburada.com/"><span
                        style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;&nbsp;internet
                      sitesini hiçbir şekilde kamu düzenini bozucu, genel ahlaka aykırı, başkalarını
                      rahatsız ve taciz edici şekilde, yasalara aykırı bir amaç için, başkalarının
                      fikri ve telif haklarına tecavüz edecek şekilde kullanamaz. Ayrıca, üye
                      başkalarının hizmetleri kullanmasını önleyici veya zorlaştırıcı faaliyet (spam,
                      virüs, truva atı, vb.) ve işlemlerde bulunamaz. Aynı şekilde, minticity.com
                      içeriğindeki yarışma, oyun vb. uygulamalara ilişkin özel bilgileri 3. şahıslarla
                      paylaşamaz ve varsa program açıklarını sisteme zarar verecek şekilde ifşa
                      edemez.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.5.</span></b><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;</span><a
                      target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                      href="http://www.hepsiburada.com/"><span
                        style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;&nbsp;internet
                      sitesinde üyeler tarafından beyan edilen, yazılan, kullanılan fikir ve
                      düşünceler, tamamen üyelerin kendi kişisel görüşleridir ve görüş sahibini
                      bağlar. Bu görüş ve düşüncelerin Minticity ile hiçbir ilgi ve bağlantısı yoktur.
                      Minticity' nin üyenin beyan edeceği fikir ve görüşler nedeniyle üçüncü kişilerin
                      uğrayabileceği zararlardan ve üçüncü kişilerin beyan edeceği fikir ve görüşler
                      nedeniyle üyenin uğrayabileceği zararlardan dolayı herhangi bir sorumluluğu
                      bulunmamaktadır.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.6.</span></b><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;Minticity,
                      üye verilerinin yetkisiz kişilerce okunmasından ve üye yazılım ve verilerine
                      gelebilecek zararlardan dolayı sorumlu olmayacaktır. Üye,&nbsp;</span><a target="_blank"
                      style="color: blue; text-decoration: underline; text-underline: single"
                      href="http://www.hepsiburada.com/"><span
                        style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;&nbsp;internet
                      sitesinin kullanılmasından dolayı uğrayabileceği herhangi bir zarar yüzünden
                      Minticity' den tazminat talep etmemeyi peşinen kabul etmiştir.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.7.</span></b><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;Üye,
                      diğer internet kullanıcılarının yazılımlarına ve verilerine izinsiz olarak
                      ulaşmamayı veya bunları kullanmamayı kabul etmiştir. Aksi takdirde, bundan
                      doğacak hukuki ve cezai sorumluluklar tamamen üyeye aittir.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.8.</span></b><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;İşbu
                      üyelik sözleşmesi içerisinde sayılan maddelerden bir ya da birkaçını ihlal eden
                      üye işbu ihlal nedeniyle cezai ve hukuki olarak şahsen sorumlu olup, Minticity’&nbsp;
                      yi bu ihlallerin hukuki ve cezai sonuçlarından ari tutacaktır. Ayrıca; işbu
                      ihlal nedeniyle, olayın hukuk alanına intikal ettirilmesi halinde, Minticity'
                      &nbsp;nin üyeye karşı üyelik sözleşmesinde uyulmamasından dolayı tazminat talebinde
                      bulunma hakkı saklıdır.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.9.</span></b><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;Minticity'
                      nin her zaman tek taraflı olarak gerektiğinde üyenin üyeliğini silme, üyeye ait
                      dosya, belge ve bilgileri silme hakkı vardır. Üye işbu tasarrufu önceden kabul
                      eder. Bu durumda, Minticity' nin hiçbir sorumluluğu yoktur.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.10.</span></b><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;</span><a
                      target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                      href="http://www.hepsiburada.com/"><span
                        style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;&nbsp;internet
                      sitesi yazılım ve tasarımı Minticity mülkiyetinde olup, bunlara ilişkin telif
                      hakkı ve/veya diğer fikri mülkiyet hakları ilgili kanunlarca korunmakta olup,
                      bunlar&nbsp;&nbsp;üye tarafından izinsiz kullanılamaz, iktisap edilemez ve değiştirilemez.
                      Bu web sitesinde adı geçen başkaca şirketler ve ürünleri sahiplerinin ticari
                      markalarıdır ve ayrıca fikri mülkiyet hakları kapsamında korunmaktadır.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.11.</span></b><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;Minticity
                      tarafından&nbsp;</span><a target="_blank"
                      style="color: blue; text-decoration: underline; text-underline: single"
                      href="http://www.hepsiburada.com/"><span
                        style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;&nbsp;internet
                      sitesinin iyileştirilmesi, geliştirilmesine yönelik olarak ve/veya yasal mevzuat
                      çerçevesinde siteye erişmek için kullanılan İnternet servis sağlayıcısının adı
                      ve Internet Protokol (IP) adresi, Siteye erişilen tarih ve saat, sitede
                      bulunulan sırada erişilen sayfalar ve siteye doğrudan bağlanılmasını sağlayan
                      Web sitesinin Internet adresi gibi birtakım bilgiler toplanabilir.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.12.</span></b><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;Minticity
                      kullanıcılarına daha iyi hizmet sunmak, ürünlerini ve hizmetlerini iyileştirmek,
                      sitenin kullanımını kolaylaştırmak için kullanımını kullanıcılarının özel
                      tercihlerine ve ilgi alanlarına yönelik çalışmalarda üyelerin kişisel
                      bilgilerini kullanabilir. Minticity, üyenin&nbsp;</span><a target="_blank"
                      style="color: blue; text-decoration: underline; text-underline: single"
                      href="http://www.hepsiburada.com/"><span
                        style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;&nbsp;internet
                      sitesi üzerinde yaptığı hareketlerin kaydını bulundurma hakkını saklı tutar.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.13.</span></b><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;minticity.com’
                      a&nbsp;üye olan kişi, yürürlükte bulunan ve/veya yürürlüğe alınacak uygulamalar
                      kapsamında Minticity ve iştiraki olan tüm şirketler tarafından&nbsp; kendisine ürün
                      ve hizmet tanıtımları, reklamlar, kampanyalar, avantajlar, anketler &nbsp;ve diğer
                      müşteri memnuniyeti uygulamaları sunulmasına izin verdiğini beyan ve kabul eder.
                      &nbsp;Üye, minticity.com’ a üye olurken ve/veya başka yollarla geçmişte vermiş olduğu
                      ve/veya gelecekte vereceği kişisel ve alışveriş bilgilerinin ve alışveriş
                      ve/veya tüketici davranış bilgilerinin&nbsp; yukarıdaki amaçlarla toplanmasına,
                      Minticity&nbsp;iştiraki olan tüm şirketler ile paylaşılmasına, Minticity ve iştiraki
                      olan tüm şirketler tarafından kullanılmasına ve arşivlenmesine izin verdiğini
                      beyan ve kabul eder. Üye aksini bildirmediği sürece &nbsp;üyeliği sona erdiğinde de
                      &nbsp;verilerin toplanmasına, Minticity iştiraki olan tüm şirketler ile
                      paylaşılmasına, Minticity ve iştiraki olan tüm şirketler tarafından
                      kullanılmasına ve arşivlenmesine izin verdiğini beyan ve kabul eder. Üye aksini
                      bildirmediği &nbsp;sürece Minticity ve &nbsp;iştiraki olan tüm şirketlerin&nbsp;kendisi ile
                      &nbsp;internet, telefon, SMS, &nbsp;vb iletişim kanalları kullanarak irtibata geçmesine
                      izin verdiğini beyan ve kabul eder. Üye yukarıda bahsi geçen bilgilerin
                      toplanması, &nbsp;paylaşılması, kullanılması, arşivlenmesi ve kendisine erişilmesi
                      nedeniyle doğrudan ve/veya dolaylı maddi ve/veya manevi menfi ve/veya müsbet,
                      velhasıl herhangi bir zarara uğradığı konusunda talepte bulunmayacağını ve
                      Minticity ve iştiraki olan şirketleri sorumlu tutmayacağını beyan ve kabul eder.
                      Üye veri paylaşım tercihlerini değiştirmek isterse, bu talebini Minticity’ nin
                      müşteri hizmetleri çağrı merkezlerine&nbsp;iletebilir.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.14.</span></b><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;Minticity,
                      üyenin kişisel bilgilerini yasal bir zorunluluk olarak istendiğinde veya (a)
                      yasal gereklere uygun hareket etmek veya Minticity’ ye tebliğ edilen yasal
                      işlemlere uymak; (b) Minticity ve Minticity web sitesi ailesinin haklarını ve
                      mülkiyetini korumak ve savunmak için gerekli olduğuna iyi niyetle kanaat
                      getirdiği hallerde açıklayabilir.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.15.</span></b><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;minticity.com
                      web sitesinin virüs ve benzeri amaçlı yazılımlardan arındırılmış olması için
                      mevcut imkanlar dahilinde tedbir alınmıştır. Bunun yanında nihai güvenliğin
                      sağlanması için kullanıcının, kendi virüs koruma sistemini tedarik etmesi ve
                      gerekli korunmayı sağlaması gerekmektedir. Bu bağlamda üye Minticity web
                      sitesine girmesiyle, kendi yazılım ve işletim sistemlerinde oluşabilecek tüm
                      hata ve bunların doğrudan ya da dolaylı sonuçlarından kendisinin sorumlu
                      olduğunu kabul etmiş sayılır.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.16.</span></b><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;Minticity,
                      sitenin içeriğini dilediği zaman değiştirme, kullanıcılara sağlanan herhangi bir
                      hizmeti değiştirme ya da sona erdirme veya Minticity web sitesinde kayıtlı
                      kullanıcı bilgi ve verilerini silme hakkını saklı tutar.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.17.</span></b><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;Minticity,
                      üyelik sözleşmesinin koşullarını hiçbir şekil ve surette ön ihbara ve/veya
                      ihtara gerek kalmaksızın her zaman değiştirebilir, güncelleyebilir veya iptal
                      edebilir. Değiştirilen, güncellenen ya da yürürlükten kaldırılan her hüküm,
                      yayın tarihinde tüm üyeler bakımından hüküm ifade edecektir.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.18.</span></b><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;Taraflar,
                      Minticity' ye ait tüm bilgisayar kayıtlarının tek ve gerçek münhasır delil
                      olarak, HMUK madde 287'ye uygun şekilde esas alınacağını ve söz konusu
                      kayıtların bir delil sözleşmesi teşkil ettiği hususunu kabul ve beyan eder.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.19.</span></b><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;Minticity,
                      iş bu üyelik sözleşmesi uyarınca, üyelerinin kendisinde kayıtlı elektronik posta
                      adreslerine bilgilendirme mailleri ve cep telefonlarına bilgilendirme SMS’ leri
                      gönderme yetkisine sahip olmakla beraber, üye işbu üyelik sözleşmesini
                      onaylamasıyla beraber bilgilendirme maillerinin elektronik posta adresine ve
                      bilgilendirme SMS’ lerinin cep telefonuna gönderilmesini kabul etmiş
                      sayılacaktır. Üye mail ve/veya SMS almaktan vazgeçmek istemesi durumunda
                      Minticity müşteri hizmetlerine iptal isteğini bildirebilir. Böylesi bir durumda
                      söz konusu bildirimler kendisine gönderilmeyecektir.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.20. </span></b>
                    <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                      www.minticity.com sitesine girilen bilgilerin ve işlemlerin güvenliği için
                      gerekli önlemler, bilgi ve işlemin mahiyetine Minticity ve/veya ilgili kart
                      kuruluşlarınca sistem ve internet altyapısında alınmıştır. Tüm kredi kartı
                      işlemleri ve onayları tarafımızdan bağımsız olarak ilgili banka ve benzeri kart
                      kuruluşlarınca online olarak üye ile ilgili kuruluş arasında
                      gerçekleştirilmektedir (Kredi kartı şifresi gibi bilgiler Minticity tarafından
                      görülmez ve kaydedilmez). Üyelerin siteye üyelik, ürün/hizmet satın alma ve
                      bilgi güncelleme amaçlı girdikleri bilgiler, özellikle kredi kartı ve banka
                      kartlarına ait gizli bilgiler diğer internet kullanıcıları tarafından
                      görüntülenemez. Bu paragraf, üyenin kredi kartı ile işlem yapacağı anlamına
                      gelmemektedir.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.21.</span></b><span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                      Şayet site üzerinde böylesi bir uygulama mevcut ise, alışveriş yapan üyelerin
                      özel istek ve talepleri uyarınca üretilen veya üzerinde değişiklik ya da
                      ilaveler yapılarak kişiye özel hale getirilen ya da niteliği itibariyle iade
                      edilemeyecek, hızla bozulma veya son kullanma tarihi geçme ihtimali olan bir
                      ürün söz konusu olduğunda ve genel olarak ürün kullanıldığında ya da
                      kullanılmamış olsa dahi ambalajından çıkarıldığında Üye cayma hakkını
                      kullanamaz. Fikri eser olan ve kopyalanabilecek olan kitap vb. materyaller için
                      iade söz konusu değildir. İade hakları ile ilgili tüm hususlar Türkiye
                      Cumhuriyeti Kanunları, Yönetmelikleri vb. ile belirlenen koşullar dahilinde
                      değerlendirilmektedir.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.22. </span></b>
                    <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                      Şayet site üzerinde böylesi bir uygulama mevcut ise, üyelerin satın aldıkları
                      ürünler Minticity tarafından seçilen bir kargo firmasıyla gönderilecektir. Kargo
                      paketi üye tarafından kontrol edilip teslim alınmalı, herhangi bir eksiklik
                      ve/veya hasar vb. olumsuz bir durum varsa bu, kargo personeli ile birlikte
                      tutanak altına alınmalıdır. Aksi takdirde; kargonun üyeye teslimi ile birlikte
                      ürün üyenin kabul edilecek ve bununla birlikte tüm sorumluluk kendisine ait
                      olacaktır. Kargo ücreti ile ilgili hususlar online alışveriş sırasında üyeye
                      bildirileceği şekildedir. Minticity kısmen veya tamamen kargo ücretini alıp
                      almamakta serbesttir.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                        3.23.</span></b><span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                      Şayet site üzerinde böylesi bir uygulama mevcut ise, Minticity, üyenin satın
                      aldığı tüm materyalleri sevkiyat tarihine kadar tedarik edememesi durumunda,
                      tedarik edemediği ürünün bedelini üyeye iade edecek ve diğer ürünleri
                      gönderecektir. Üye kendisine gönderilen ürünleri, yine ürünlerle birlikte
                      gönderilecek olan faturadan takip edebilir. O an için tedarik edilemeyen ürün
                      daha sonra bulunduğu takdirde, üyeye bilgi verilecektir. Bu durumda üyenin
                      talebi doğrultusunda işlem yapılacaktır.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 13.5pt; font-family: Verdana,sans-serif; color: black">
                        4. Diğer Hususlar</span></b>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">Ek
                      bilgi almak istediğiniz konularda +90 232 445 10 08 numaralı DAS Akademie
                      Müşteri Hizmetleri telefonumuzdan, </span>
                    <a style="color: blue; text-decoration: underline; text-underline: single"
                      href="mailto:info@das-akademie.">
                      <span style="font-size: 9.0pt; font-family: Verdana,sans-serif">
                        info@das-akademie.</span></a><span class="MsoHyperlink"><span
                        style="font-size: 9.0pt; font-family: Verdana,sans-serif">de</span></span><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                      eposta adresinden veya www.minticity.com adresinden Minticity’ ye
                      danışabilirsiniz.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                      Site üzerinde işlem yapan kişinin 18 yaşından küçük olması durumunda, kendisine
                      önceden üyelik giriş bilgileri iletilmiş olan velisi tüm işlemlerden sorumlu
                      olacaktır. Minticity sadece öğrenci velileri ile bilgi paylaşımı yapmaktadır.
                      Velisi bulunduğu öğrencinin sistemi yalnız başına kullanmasını istemeyen
                      veliler, şifre vb. izin verilen giriş bilgilerini kendilerine özel olarak
                      değiştirerek, siteye kendileri dışında girişi imkansız kılabilirler.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 13.5pt; font-family: Verdana,sans-serif; color: black">
                        5. Sözleşmenin Süresi ve Feshi</span></b>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                      İşbu sözleşme üyeye bildirilen aktivasyon tarihinden itibaren, 9 aylık kullanım
                      süresinin dolmasına (her halukarda en fazla 1 yıl) veya Minticity tarafından
                      üyeliğinin iptal edilmesine kadar yürürlükte kalacaktır. Minticity üyenin üyelik
                      sözleşmesinin herhangi bir hükmünü ihlal etmesi durumunda üyenin üyeliğini iptal
                      ederek sözleşmeyi tek taraflı olarak feshedebilecektir.</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal"
                    style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 13.5pt; font-family: Verdana,sans-serif; color: black">
                        6. İhtilafların Halli</span></b>
                  </p>
                  <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                      İşbu sözleşmeye ilişkin ihtilaflarda İZMİR Mahkemeleri ve İcra Daireleri
                      yetkilidir.</span>
                  </p>
                  <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white">
                    <b>
                      <span style="font-size: 13.5pt; font-family: Verdana,sans-serif; color: black">
                        7. Yürürlük</span></b>
                  </p>
                  <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white">
                    <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">
                      Üyenin, üyelik kaydı yapması üyenin üyelik sözleşmesinde yer alan tüm maddeleri
                      okuduğu ve üyelik sözleşmesinde yer alan maddeleri kabul ettiği anlamına gelir.
                      İşbu Sözleşme üyenin üye olması anında akdedilmiş ve karşılıklı olarak yürürlüğe
                      girmiştir.</span>
                  </p>
                  <p class="MsoNormal">&nbsp;</p>
                  <p class="MsoNormal" style="text-align: center; line-height: normal" align="center">
                    <b><i><span style="font-family: Verdana,sans-serif">
                          <a style="color: blue; text-decoration: underline; text-underline: single"
                            href="http://www.minticity.com">
                            www.minticity.com</a></span></i></b>
                  </p>
                  <p class="MsoNormal" style="text-align: center; line-height: normal" align="center">
                    <b><span style="font-family: Verdana,sans-serif">Site Gizlilik Bildirimi
                        (Privacy Policy)</span></b>
                  </p>
                  <p class="MsoNormal" style="text-align: center; line-height: normal" align="center">
                    <b><span style="font-family: Verdana,sans-serif">&nbsp;</span></b>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">minticity.com
                      “Minticity”, gizliliğinizi korumak konusunda kararlıdır. Bu gizlilik bildirimi,
                      minticity.com site ve sitelerinin (“Site”) veri toplama ve kullanma
                      uygulamalarını açıklar. Bu siteye erişmeniz bu gizlilik bildiriminde tanımlanan,
                      bilgi toplama ve kullanma uygulamalarını kabul ediyor olduğunuzu gösterir.</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Bu bildirimde
                      ve aksi belirtilmedikçe, Site üzerinde sağladığınız kişisel bilgiler izniniz
                      olmaksızın minticity.com ve denetlediği yan kuruluşları ve bağlı kuruluşları
                      dışında paylaşılmayacaktır&nbsp;(minticity.com bir Özel Alman Dil Hizmetleri Eğitimi
                      Tercüme Ticaret Limited Şirketi uygulamasıdır).</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal"><b><i>
                        <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Kişisel
                          Bilgilerinizin Toplanması</span></i></b></p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal"><b><i>
                        <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span></i></b>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Bu bilgileri,
                      minticity.com’ a kayıt olurken ya da minticity.com ürünleri ve hizmetleri
                      hakkında bilgi alma, yarışmalara katılma, e-posta haber bültenleri sipariş etme,
                      erişim sınırlaması olan özel site veya hizmetlere katılma, bir etkinlik veya
                      eğitime kaydolma, site üzerinden herhangi bir satın alma işleminde bulunma gibi
                      talep ettiğiniz bir işlemi gerçekleştirmenize veya size hizmet sağlamak için
                      sizinle iletişim kurmamıza izin veren, sizi kişi olarak tanıtan bilgilere
                      (kişisel bilgiler) gerek duyduğumuz zaman sizden isteriz. Topladığımız kişisel
                      bilgiler arasında adınız, unvanınız, şirket veya kuruluşunuzun adı, iş e-posta
                      adresiniz, iş telefonunuz, iş veya ev adresiniz ve iş tanımınızla ile ilgili
                      bilgiler olabilir.</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Site,
                      ziyaretleriniz hakkında, Siteye erişmek için kullandığınız Internet servis
                      sağlayıcısının adı ve Internet Protokol (IP) adresi, Siteye erişme tarihi ve
                      saatiniz, Sitede bulunduğunuz sırada eriştiğiniz sayfalar ve sitemize doğrudan
                      bağlanmanızı sağlayan Web sitesinin Internet adresi gibi birtakım bilgiler
                      toplayabilir. Bu bilgiler sitenin iyileştirilmesi, eğilimlerin analiz edilmesi
                      ve Sitenin yönetilmesi için kullanılır.</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Site kullanımı,
                      üyeleri, ürünleri ve ilgili teknolojiler hakkındaki bilgileri ve haberleri
                      paylaşmak üzere minticity.com çalışanları, uzmanları ve sizinle eş düzey
                      kullanıcılarla iletişime girme olanakları sağlar. minticity.com, e-posta
                      adresinizin veya diğer kişisel bilgilerinizin başkaları tarafından toplanmasını,
                      uygunsuz veya zararlı amaçlar için kullanılmasını önlemek için, gerçek e-posta
                      adresinizi veya diğer kişisel bilgilerinizi, yorumlar veya diğer genel
                      forumlarda açıklamamaya dikkat etmeniz konusunda sizi uyarır.</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal"><b><i>
                        <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Kişisel
                          Bilgilerinizin Kullanımı</span></i></b></p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Sitede toplanan
                      kişisel bilgiler, Sitenin işletilmesi ve istediğiniz veya yetkilendirdiğiniz
                      hizmetlerin sağlanması ya da işlemlerin yerine getirilmesi için kullanılır.</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">minticity.com
                      bu kullanımları desteklemek üzere, müşterilerine daha etkili hizmet sunmak,
                      Siteyi ve diğer ilgili minticity.com ürünlerini veya hizmetlerini iyileştirmek
                      ve aynı bilgileri tekrar tekrar girme gereğini ortadan kaldırarak Sitenin
                      kullanımını daha kolay hale getirmek veya Siteyi özel tercihlerinize ve ilgi
                      alanlarınıza göre özelleştirmek için kişisel bilgileri kullanabilir.
                      minticity.com ile ilişkilerinizin dengeli sürmesini sağlamak için, minticity.com
                      tarafından kullanılan bilgiler diğer minticity.com hizmetleri tarafından
                      toplanan bilgilerle birleştirilebilir.</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Kişisel
                      bilgilerinizi, kritik güncelleştirmeleri ve bildirimleri de içerecek şekilde,
                      kullanmakta olduğunuz ürün veya hizmetler hakkında önemli bilgiler sağlamak için
                      kullanabiliriz. Ayrıca, size diğer minticity.com ürünleri ve hizmetleri hakkında
                      çeşitli yollarla bilgiler gönderebilir ve/veya kendi ürünleri ve hizmetleri
                      hakkında bilgi gönderebilmeleri için bu bilgileri diğer minticity.com
                      ortaklarıyla paylaşabiliriz.</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Araştırma
                      amacıyla, site ziyaretleriyle ilgili verileri anonim demografik bilgilerle
                      birleştiririz ve bu bilgileri daha yararlı içerik sağlamak üzere toplu bir
                      şekilde kullanabiliriz. minticity.com sitesinin giriş sınırlaması olan kimi
                      bölümlerinde, kişiselleştirilmiş içerik sağlamak için, sizden onay alarak site
                      ziyaret verilerini kişisel bilgilerinizle birleştirebiliriz.</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Site üyelik ve
                      satın alma sözleşmesi ile e-postalarını almayı kabul ettiğiniz minticity.com,
                      tıklattığınız e-postaları izlemek için özelleştirilmiş bağlantılar veya benzeri
                      teknolojiler kullanabilir. Size daha uygun e-postalar veya satış bilgileri
                      gönderebilmek için bu bilgileri kişisel bilgilerinizle ilişkilendirebiliriz. Her
                      e-posta, bu tür iletilerin gelmesini durdurmanıza olanak veren, abonelik iptal
                      bağlantıları içerir.</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif"><br>
                      Sitemizdeki kayıt formları, anketler ve yarışmalar; iletişim bilgilerinizi
                      (adınız, soyadınız, email adresiniz, telefon numaralarınız, posta adresiniz,
                      vb.) ve kişisel bilgilerinizi (yaşınız, mesleğiniz, vb.) vermenizi talep
                      edebilir. Minticity.com web sitelerini ziyaret eden kullanıcıların bilgileri
                      (ziyaret süresi, zamanı, görüntülenen sayfalar) onlara daha iyi hizmet edebilmek
                      amacı ile takip edilmektedir. Elde edilen bilgiler, gizlilik prensiplerine bağlı
                      kalmak kaydıyla, içerik bölümümüzü zenginleştirmek ve iyileştirmek amacı ile
                      anket, reklam vb. konularda kullanılabilir. Bu işlemler sonucunda verdiğiniz
                      iletişim bilgileri üzerinden sizinle iletişime geçilmesini kabul etmiş
                      olursunuz. minticity.com’ dan tarafınıza gönderilecek e-Bülten ve/veya
                      bilgilendirme e-maillerini almak istememeniz durumunda, e-mail içeriğinde yer
                      alan listeden çıkış isteği bağlantısına tıklanarak engellenebilir.</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Minticity.com,
                      kişisel bilgilerinizi yasal bir zorunluluk olarak istendiğinde veya (a) yasal
                      gereklere uygun hareket etmek veya Minticity.com ya da Siteye tebliğ edilen
                      yasal işlemlere uymak; (b) Minticity.com ve Web sitesi ailemizin haklarını ve
                      mülkiyetini korumak ve savunmak; (c) Minticity.com çalışanlarının veya
                      aracılarının, Minticity.com ürünü kullananların veya kamu güvenliği açısından
                      acil durumlarda harekete geçmek için gerekli olduğuna iyi niyetle kanaat
                      getirdiği hallerde açıklayabilir.</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal"><b><i>
                        <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Kişisel
                          Bilgilerinize Erişim</span></i></b></p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal"><b><i>
                        <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span></i></b>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Bu Sitede
                      sağladığınız kişisel bilgiler ve bağlantı tercihlerinizi kendi sayfanızda
                      inceleyebilir ve düzenleyebilirsiniz. Kişisel bilgileriniz görüntülenmeden önce,
                      kullanıcı adı ve parolanızı girmeniz istenir.</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">minticity.com
                      üzerinde sunulan kimi hizmetler Profil Merkezi' nden erişilemeyen bilgiler
                      toplayabilir. Ancak, bu türden durumlarda kişisel bilgilerinize, bu bildirimin
                      sonunda açıklanan şekilde minticity.com ile bağlantı kurarak veya söz konusu
                      hizmet tarafından açıklanan başka yollarla erişebilirsiniz.</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal"><b><i>
                        <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span></i></b>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal"><b><i>
                        <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Kişisel
                          Bilgilerinizin Güvenliği</span></i></b></p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">minticity.com,
                      kişisel bilgilerinizin güvenliğini korumayı ilke edinmiştir. Kişisel
                      bilgilerinizi yetkisiz erişime, kullanıma veya açığa çıkmaya karşı korumak için
                      çok çeşitli güvenlik teknolojileri ve yordamları kullanırız. Örneğin,
                      sağladığınız bilgileri kontrol altındaki tesislerde bulunan ve sınırlı erişimi
                      olan bilgisayar sunucularında depolarız.</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Kredi kartı ile
                      işlem yapıldığı takdirde; www.minticity.com sitesine girilen bilgilerin ve
                      işlemlerin güvenliği için gerekli önlemler, bilgi ve işlemin mahiyetine
                      Minticity ve/veya ilgili kart kuruluşlarınca sistem ve internet altyapısında
                      alınmıştır. Tüm kredi kartı işlemleri ve onayları tarafımızdan bağımsız olarak
                      ilgili banka ve benzeri kart kuruluşlarınca online olarak üye ile ilgili kuruluş
                      arasında gerçekleştirilmektedir (Kredi kartı şifresi gibi bilgiler Minticity
                      tarafından görülmez ve kaydedilmez). Üyelerin siteye üyelik, ürün/hizmet satın
                      alma ve bilgi güncelleme amaçlı girdikleri bilgiler, özellikle kredi kartı ve
                      banka kartlarına ait gizli bilgiler diğer internet kullanıcıları tarafından
                      görüntülenemez.</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal"><b><i>
                        <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Bu Gizlilik
                          Bildiriminde Yapılabilecek Değişiklikler</span></i></b></p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal"><b><i>
                        <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;</span></i></b>
                  </p>
                  <p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;line-height:normal">
                    <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Bu gizlilik
                      bildirimini zaman zaman güncelleştirebiliriz. Hizmeti kullanmanız bu gizlilik
                      bildirimini ve yapılabilecek güncelleştirmeleri kabul ettiğiniz anlamına gelir.</span>
                  </p>
                  <p class="MsoNormal" style="text-align:justify">
                    <span style="font-size: 10.0pt; line-height: 115%; font-family: Verdana,sans-serif">
                      &nbsp;</span>
                  </p>
                  <p></p>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-info text-white"
                @click="modal('parent', 'parentActivationAgreement', 'hide')">Schließen
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="section === 'selectBranch' && !child" class="align-items-center container d-flex justify-content-center">
      <div class="container">
        <div class="row">
          <div class="col-8 offset-2">
            <div class="card">
              <div class="card-body">
                <h3 class="text-center">{{ school.selected.name }}</h3>
                <h5>Lütfen Okulunuzu Seçiniz</h5>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1">Okul Ara</span>
                  </div>
                  <input id="globSearch" v-model="globSearch" type="text" class="form-control" autocomplete="off">
                  <div v-if="globSearch.length" @click="globSearch = ''" class="input-group-append">
                    <label for="globSearch" class="input-group-text btn btn-info text-white">Aramayı
                      Sil</label>
                  </div>
                </div>
                <table class="table table-striped table-hover">
                  <tbody>
                    <tr v-for="child in getSchoolChildren" :key="'sch_' + child.name">
                      <td>{{ child.name }}</td>
                      <td>
                        <button class="btn btn-sm py-0 btn-success" @click="selectChildrenSchool(child)">Seçiniz</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="section === 'selectBranch' && child"
      class="align-items-center container h-100 d-flex justify-content-center">
      <div class="container">
        <div class="row">
          <div class="col-8 offset-2">
            <div class="card">
              <div class="card-body">
                <h3 class="text-center">{{ child.name }}</h3>
                <h5 class="bg-gradient-danger text-white p-2 text-center">
                  Aktivasyon kodları tek kullanımlıktır. Lütfen bu hususa dikkat ederek bilgilerinizi kontrol ediniz!!
                </h5>
                <table class="table">
                  <tbody>
                    <tr>
                      <td>Okul Numarasınızı Giriniz</td>
                      <td>
                        <div class="input-group mb-3">
                          <input :disabled="selectUser" type="text" v-model="schoolnumber" class="form-control"
                            autocomplete="off">
                          <div class="input-group-append">
                            <button :disabled="selectUser"
                              class="input-group-text cursor-pointer text-white btn btn-success"
                              @click="checkSchoolNumber">Kontrol Et</button>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="selectUser">
                      <td>
                        Sen misin?
                      </td>
                      <td>
                        {{ selectUser.username }}
                        <p class="mb-0 pb-0 pt-2">
                          <button class="btn btn-success py-0" @click="setSection('selectUser')">Evet</button>
                          <button class="btn btn-danger py-0"
                            @click="selectUser = null; schoolnumber = null">Hayır</button>
                        </p>
                      </td>
                    </tr>
                    <tr v-if="error">
                      <td colspan="2" class="bg-gradient-danger text-white">{{ error }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="section === 'selectUser'" class="align-items-center container d-flex h-100 justify-content-center">
      <activation-form :html="studentPrefix.values.html">
        <error :visible="studentPrefix.form.has('info')" :errors="studentPrefix.form.get('info')"></error>
        <form class="activation-form" @submit.prevent="submitStudentFormPrefix"
          @keydown="studentPrefix.form.clear($event.target.id)">
          <div class="floating-label">
            <input type="text" :value="selectUser.username" disabled="true">
            <label for="personal_number" class="pl-2">Username</label>
          </div>
          <div class="floating-label">
            <input required id="code" type="text" :placeholder="studentPrefix.values.code"
              v-model="studentPrefix.form.code" oninput="this.value = this.value.trim()">
            <label for="code" class="pl-2" v-text="studentPrefix.values.code"></label>
          </div>
          <error :visible="studentPrefix.form.has('code')" :errors="studentPrefix.form.get('code')"></error>
          <div class="floating-label">
            <input required id="email" type="email" v-model="studentPrefix.form.email"
              :placeholder="studentPrefix.values.email">
            <label for="email" class="pl-2" v-text="studentPrefix.values.email"></label>
          </div>
          <error :visible="studentPrefix.form.has('email')" :errors="studentPrefix.form.get('email')"></error>
          <div class="floating-label">
            <input required id="password" v-model="studentPrefix.form.password" :type="studentPrefix.form.passwordType"
              :placeholder="studentPrefix.values.password">
            <label for="password" class="pl-2" v-text="studentPrefix.values.password"></label>
            <div @click="studentPrefix.form.togglePassword()"
              class="icon d-flex justify-content-center align-items-center">
              <span v-if="studentPrefix.form.showPassword" class="fa fa-eye"></span>
              <span v-else class="fa fa-eye-slash"></span>
            </div>
          </div>
          <error :visible="studentPrefix.form.has('password')" :errors="studentPrefix.form.get('password')"></error>

          <div class="floating-label">
            <input required id="password_confirmation" :type="studentPrefix.form.passwordType"
              v-model="studentPrefix.form.password_confirmation"
              :placeholder="studentPrefix.values.password_confirmation">
            <label for="password_confirmation" class="pl-2" v-text="studentPrefix.values.password_confirmation"></label>
            <div @click="studentPrefix.form.togglePassword()"
              class="icon d-flex justify-content-center align-items-center">
              <span v-if="studentPrefix.form.showPassword" class="fa fa-eye"></span>
              <span v-else class="fa fa-eye-slash"></span>
            </div>
          </div>
          <error :visible="studentPrefix.form.has('password_confirmation')"
            :errors="studentPrefix.form.get('password_confirmation')"></error>

          <div class="d-block w-100 d-flex justify-content-start align-items-center flex-column flex-sm-row">
            <div @click="studentPrefix.form.agreement = !studentPrefix.form.agreement" id="checkbox-container"
              class="toggle-btn" :class="studentPrefix.form.agreement ? 'active' : ''">
              <input id="checkbox" type="checkbox" class="cb-value" />
              <label for="checkbox" class="round-btn"></label>
            </div>

            <span class="font-weight-bold mb-3 mb-sm-0 cursor-pointer">
              <a @click.prevent="modal('student', 'studentActivationAgreement', 'show')"
                class="float-left text-reset hover:underline">Üyelik sözleşmesini okuduğumu kabul ediyorum!</a>
            </span>
          </div>

          <div class="d-flex justify-content-around w-100 flex-column flex-sm-row">
            <button @click.prevent="sendToLink('/')" class="btn btn-lg w-100 btn-info text-white mb-2 mb-sm-0 mr-sm-3"
              type="submit">
              {{ studentPrefix.values.homePage }}
            </button>
            <button class="btn btn-lg w-100 bg-gradient-success text-white mb-2 mb-sm-0 mr-sm-3"
              :disabled="studentPrefix.form.any() && !studentPrefix.form.get('info')" type="submit">
              {{ studentPrefix.values.submit }}
            </button>
            <!-- <button @click.prevent="sendToLink('/login')"
              class="btn btn-lg w-100 bg-gradient-success text-white mb-2 mb-sm-0 mr-sm-3"
              :disabled="studentPrefix.form.any() && !studentPrefix.form.get('info')" type="submit">
              Giriş Yap
            </button> -->
          </div>
        </form>
      </activation-form>
      <div class="modal" id="studentActivationAgreement" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <div>
                <p></p>
                <p class="MsoNormal"
                  style="text-align: center; line-height: normal; margin-bottom: .0001pt; background: white"
                  align="center"><b> <span style="font-size: 18.0pt; font-family: Verdana,sans-serif; color: black">
                      minticity.com ÜYELİK SÖZLEŞMESİ </span>
                  </b></p>
                <p class="MsoNormal"
                  style="text-align: center; line-height: normal; margin-bottom: .0001pt; background: white"
                  align="center"> <span style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"><b> <span
                      style="font-size: 13.5pt; font-family: Verdana,sans-serif; color: black"> 1. Taraflar</span></b>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">a)</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    www.minticity.com&nbsp;
                    internet sitesinin faaliyetlerini yürüten Şair Eşref Bulvarı,
                    1371 Sok. No:5 Alkan İşhanı Kat:4-5 adresinde mukim Özel Alman Dil Hizmetleri Eğitimi Tercüme Ticaret
                    Limited Şirketi (Bundan böyle “Minticity” veya “DAS AKADEMIE” olarak anılacaktır).</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"><b> <span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">b)</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Belirli bir dönem için www.minticity.com&nbsp;
                    internet sitesine üye olan internet kullanıcısı ("Üye").</span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"><b> <span
                      style="font-size: 13.5pt; font-family: Verdana,sans-serif; color: black"> 2. Sözleşmenin
                      Konusu</span></b>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> İşbu Sözleşme’ nin konusu
                    Minticity’ &nbsp;
                    nin sahip olduğu internet sitesi&nbsp;
                  </span><a target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                    href="http://www.hepsiburada.com/"><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    ‘ dan üyenin faydalanma şartlarının belirlenmesidir.</span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"><b> <span
                      style="font-size: 13.5pt; font-family: Verdana,sans-serif; color: black"> 3. Tarafların Hak ve
                      Yükümlülükleri</span></b>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.1.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Üye,
                    &nbsp;
                  </span><a target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                    href="http://www.hepsiburada.com/"><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    &nbsp;
                    internet sitesine üye olurken verdiği kişisel ve diğer sair bilgilerin kanunlar önünde doğru olduğunu,
                    Minticity' nin bu bilgilerin gerçeğe aykırılığı nedeniyle
                    uğrayacağı tüm zararları aynen ve derhal tazmin edeceğini kabul,
                    beyan ve taahhüt eder.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.2.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Üye,
                    Minticity ve/veya Eğitim görmekte olduğu okul tarafından kendisine bildirilen 9 aylık süre dahilinde
                    (her halukarda en fazla 1 yıl) geçerli olacak şekilde verilebilecek olan okul kodu,
                    kullanıcı numarası,
                    kullanıcı adı,
                    şifre,
                    aktivasyon kodu vb. hiçbir bilgiyi başka kişi ya da kuruluşlara veremez,
                    üyenin söz konusu bilgileri kullanma hakkı bizzat kendisine / velisine aittir. Bu sebeple doğabilecek
                    tüm sorumluluk ile üçüncü kişiler veya yetkili merciler tarafından Minticity' ye karşı ileri
                    sürülebilecek tüm iddia ve taleplere karşı,
                    Minticity' nin söz konusu izinsiz kullanımdan kaynaklanan her türlü tazminat ve
                    sair talep hakkı saklıdır.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.3.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Üye,
                    &nbsp;
                  </span><a target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                    href="http://www.hepsiburada.com/"><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    &nbsp;
                    internet sitesini kullanırken yasal mevzuat hükümlerine riayet etmeyi ve bunları ihlal etmemeyi baştan
                    kabul ve taahhüt eder. Aksi takdirde,
                    doğacak tüm hukuki ve cezai yükümlülükler tamamen ve münhasıran üyeyi bağlayacaktır.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.4.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Üye,
                    &nbsp;
                  </span><a target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                    href="http://www.hepsiburada.com/"><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    &nbsp;
                    internet sitesini hiçbir şekilde kamu düzenini bozucu,
                    genel ahlaka aykırı,
                    başkalarını rahatsız ve taciz edici şekilde,
                    yasalara aykırı bir amaç için,
                    başkalarının fikri ve telif haklarına tecavüz edecek şekilde kullanamaz. Ayrıca,
                    üye başkalarının hizmetleri kullanmasını önleyici veya zorlaştırıcı faaliyet (spam,
                    virüs,
                    truva atı,
                    vb.) ve işlemlerde bulunamaz. Aynı şekilde,
                    minticity.com içeriğindeki yarışma,
                    oyun vb. uygulamalara ilişkin özel bilgileri 3. şahıslarla paylaşamaz ve varsa program açıklarını
                    sisteme zarar verecek şekilde ifşa edemez.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.5.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span><a target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                    href="http://www.hepsiburada.com/"><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    &nbsp;
                    internet sitesinde üyeler tarafından beyan edilen,
                    yazılan,
                    kullanılan fikir ve düşünceler,
                    tamamen üyelerin kendi kişisel görüşleridir ve görüş sahibini bağlar. Bu görüş ve düşüncelerin
                    Minticity ile hiçbir ilgi ve bağlantısı yoktur. Minticity' nin üyenin beyan edeceği fikir ve görüşler
                    nedeniyle üçüncü kişilerin
                    uğrayabileceği zararlardan ve üçüncü kişilerin beyan edeceği fikir ve görüşler nedeniyle üyenin
                    uğrayabileceği zararlardan dolayı herhangi bir sorumluluğu bulunmamaktadır.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.6.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Minticity,
                    üye verilerinin yetkisiz kişilerce okunmasından ve üye yazılım ve verilerine gelebilecek zararlardan
                    dolayı sorumlu olmayacaktır. Üye,
                    &nbsp;
                  </span><a target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                    href="http://www.hepsiburada.com/"><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    &nbsp;
                    internet sitesinin kullanılmasından dolayı uğrayabileceği herhangi bir zarar yüzünden Minticity' den
                    tazminat talep etmemeyi peşinen kabul etmiştir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.7.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Üye,
                    diğer internet kullanıcılarının yazılımlarına ve verilerine izinsiz olarak ulaşmamayı veya bunları
                    kullanmamayı kabul etmiştir. Aksi takdirde,
                    bundan doğacak hukuki ve cezai sorumluluklar tamamen üyeye aittir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.8.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    İşbu üyelik sözleşmesi içerisinde sayılan maddelerden bir ya da birkaçını ihlal eden üye işbu ihlal
                    nedeniyle cezai ve hukuki olarak şahsen sorumlu olup,
                    Minticity’&nbsp;
                    yi bu ihlallerin hukuki ve cezai sonuçlarından ari tutacaktır. Ayrıca;
                    işbu ihlal nedeniyle,
                    olayın hukuk alanına intikal ettirilmesi halinde,
                    Minticity'
                    &nbsp;
                    nin üyeye karşı üyelik sözleşmesinde uyulmamasından dolayı tazminat talebinde bulunma hakkı
                    saklıdır.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.9.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Minticity'
                    nin her zaman tek taraflı olarak gerektiğinde üyenin üyeliğini silme,
                    üyeye ait dosya,
                    belge ve bilgileri silme hakkı vardır. Üye işbu tasarrufu önceden kabul eder. Bu durumda,
                    Minticity' nin hiçbir sorumluluğu yoktur.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.10.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span><a target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                    href="http://www.hepsiburada.com/"><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    &nbsp;
                    internet sitesi yazılım ve tasarımı Minticity mülkiyetinde olup,
                    bunlara ilişkin telif hakkı ve/veya diğer fikri mülkiyet hakları ilgili kanunlarca korunmakta olup,
                    bunlar&nbsp;
                    &nbsp;
                    üye tarafından izinsiz kullanılamaz,
                    iktisap edilemez ve değiştirilemez. Bu web sitesinde adı geçen başkaca şirketler ve ürünleri
                    sahiplerinin ticari markalarıdır ve ayrıca fikri mülkiyet hakları kapsamında korunmaktadır.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.11.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Minticity tarafından&nbsp;
                  </span><a target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                    href="http://www.hepsiburada.com/"><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    &nbsp;
                    internet sitesinin iyileştirilmesi,
                    geliştirilmesine yönelik olarak ve/veya yasal mevzuat çerçevesinde siteye erişmek için kullanılan
                    İnternet servis sağlayıcısının adı ve Internet Protokol (IP) adresi,
                    Siteye erişilen tarih ve saat,
                    sitede bulunulan sırada erişilen sayfalar ve siteye doğrudan bağlanılmasını sağlayan Web sitesinin
                    Internet adresi gibi birtakım bilgiler toplanabilir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.12.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Minticity kullanıcılarına daha iyi hizmet sunmak,
                    ürünlerini ve hizmetlerini iyileştirmek,
                    sitenin kullanımını kolaylaştırmak için kullanımını kullanıcılarının özel tercihlerine ve ilgi
                    alanlarına yönelik çalışmalarda üyelerin kişisel bilgilerini kullanabilir. Minticity,
                    üyenin&nbsp;
                  </span><a target="_blank" style="color: blue; text-decoration: underline; text-underline: single"
                    href="http://www.hepsiburada.com/"><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif">www.minticity.com</span></a><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    &nbsp;
                    internet sitesi üzerinde yaptığı hareketlerin kaydını bulundurma hakkını saklı tutar.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.13.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    minticity.com’ a&nbsp;
                    üye olan kişi,
                    yürürlükte bulunan ve/veya yürürlüğe alınacak uygulamalar kapsamında Minticity ve iştiraki olan tüm
                    şirketler tarafından&nbsp;
                    kendisine ürün ve hizmet tanıtımları,
                    reklamlar,
                    kampanyalar,
                    avantajlar,
                    anketler &nbsp;
                    ve diğer müşteri memnuniyeti uygulamaları sunulmasına izin verdiğini beyan ve kabul eder. &nbsp;
                    Üye,
                    minticity.com’ a üye olurken ve/veya başka yollarla geçmişte vermiş olduğu ve/veya gelecekte vereceği
                    kişisel ve alışveriş bilgilerinin ve alışveriş ve/veya tüketici davranış bilgilerinin&nbsp;
                    yukarıdaki amaçlarla toplanmasına,
                    Minticity&nbsp;
                    iştiraki olan tüm şirketler ile paylaşılmasına,
                    Minticity ve iştiraki olan tüm şirketler tarafından kullanılmasına ve arşivlenmesine izin verdiğini
                    beyan ve kabul eder. Üye aksini bildirmediği sürece &nbsp;
                    üyeliği sona erdiğinde de &nbsp;
                    verilerin toplanmasına,
                    Minticity iştiraki olan tüm şirketler ile paylaşılmasına,
                    Minticity ve iştiraki olan tüm şirketler tarafından kullanılmasına ve arşivlenmesine izin verdiğini
                    beyan ve kabul eder. Üye aksini bildirmediği &nbsp;
                    sürece Minticity ve &nbsp;
                    iştiraki olan tüm şirketlerin&nbsp;
                    kendisi ile &nbsp;
                    internet,
                    telefon,
                    SMS,
                    &nbsp;
                    vb iletişim kanalları kullanarak irtibata geçmesine izin verdiğini beyan ve kabul eder. Üye yukarıda
                    bahsi geçen bilgilerin toplanması,
                    &nbsp;
                    paylaşılması,
                    kullanılması,
                    arşivlenmesi ve kendisine erişilmesi nedeniyle doğrudan ve/veya dolaylı maddi ve/veya manevi menfi
                    ve/veya müsbet,
                    velhasıl herhangi bir zarara uğradığı konusunda talepte bulunmayacağını ve Minticity ve iştiraki olan
                    şirketleri sorumlu tutmayacağını beyan ve kabul eder. Üye veri paylaşım tercihlerini değiştirmek
                    isterse,
                    bu talebini Minticity’ nin müşteri hizmetleri çağrı merkezlerine&nbsp;
                    iletebilir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.14.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Minticity,
                    üyenin kişisel bilgilerini yasal bir zorunluluk olarak istendiğinde veya (a) yasal gereklere uygun
                    hareket etmek veya Minticity’ ye tebliğ edilen yasal işlemlere uymak;
                    (b) Minticity ve Minticity web sitesi ailesinin haklarını ve mülkiyetini korumak ve savunmak için
                    gerekli olduğuna iyi niyetle kanaat getirdiği hallerde açıklayabilir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.15.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    minticity.com web sitesinin virüs ve benzeri amaçlı yazılımlardan arındırılmış olması için mevcut
                    imkanlar dahilinde tedbir alınmıştır. Bunun yanında nihai güvenliğin sağlanması için kullanıcının,
                    kendi virüs koruma sistemini tedarik etmesi ve gerekli korunmayı sağlaması gerekmektedir. Bu bağlamda
                    üye Minticity web sitesine girmesiyle,
                    kendi yazılım ve işletim sistemlerinde oluşabilecek tüm hata ve bunların doğrudan ya da dolaylı
                    sonuçlarından kendisinin sorumlu olduğunu kabul etmiş sayılır.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.16.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Minticity,
                    sitenin içeriğini dilediği zaman değiştirme,
                    kullanıcılara sağlanan herhangi bir hizmeti değiştirme ya da sona erdirme veya Minticity web sitesinde
                    kayıtlı kullanıcı bilgi ve verilerini silme hakkını saklı tutar.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.17.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Minticity,
                    üyelik sözleşmesinin koşullarını hiçbir şekil ve surette ön ihbara ve/veya ihtara gerek kalmaksızın
                    her zaman değiştirebilir,
                    güncelleyebilir veya iptal edebilir. Değiştirilen,
                    güncellenen ya da yürürlükten kaldırılan her hüküm,
                    yayın tarihinde tüm üyeler bakımından hüküm ifade edecektir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.18.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Taraflar,
                    Minticity' ye ait tüm bilgisayar kayıtlarının tek ve gerçek münhasır delil
                    olarak,
                    HMUK madde 287'ye uygun şekilde esas alınacağını ve söz konusu
                    kayıtların bir delil sözleşmesi teşkil ettiği hususunu kabul ve beyan eder.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.19.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                    Minticity,
                    iş bu üyelik sözleşmesi uyarınca,
                    üyelerinin kendisinde kayıtlı elektronik posta adreslerine bilgilendirme mailleri ve cep telefonlarına
                    bilgilendirme SMS’ leri gönderme yetkisine sahip olmakla beraber,
                    üye işbu üyelik sözleşmesini onaylamasıyla beraber bilgilendirme maillerinin elektronik posta adresine
                    ve bilgilendirme SMS’ lerinin cep telefonuna gönderilmesini kabul etmiş sayılacaktır. Üye mail ve/veya
                    SMS almaktan vazgeçmek istemesi durumunda Minticity müşteri hizmetlerine iptal isteğini bildirebilir.
                    Böylesi bir durumda söz konusu bildirimler kendisine gönderilmeyecektir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.20. </span></b>
                  <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> www.minticity.com
                    sitesine girilen bilgilerin ve işlemlerin güvenliği için gerekli önlemler,
                    bilgi ve işlemin mahiyetine Minticity ve/veya ilgili kart kuruluşlarınca sistem ve internet
                    altyapısında alınmıştır. Tüm kredi kartı işlemleri ve onayları tarafımızdan bağımsız olarak ilgili
                    banka ve benzeri kart kuruluşlarınca online olarak üye ile ilgili kuruluş arasında
                    gerçekleştirilmektedir (Kredi kartı şifresi gibi bilgiler Minticity tarafından görülmez ve
                    kaydedilmez). Üyelerin siteye üyelik,
                    ürün/hizmet satın alma ve bilgi güncelleme amaçlı girdikleri bilgiler,
                    özellikle kredi kartı ve banka kartlarına ait gizli bilgiler diğer internet kullanıcıları tarafından
                    görüntülenemez. Bu paragraf,
                    üyenin kredi kartı ile işlem yapacağı anlamına gelmemektedir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.21.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> Şayet site üzerinde böylesi
                    bir uygulama mevcut ise,
                    alışveriş yapan üyelerin özel istek ve talepleri uyarınca üretilen veya üzerinde değişiklik ya da
                    ilaveler yapılarak kişiye özel hale getirilen ya da niteliği itibariyle iade edilemeyecek,
                    hızla bozulma veya son kullanma tarihi geçme ihtimali olan bir ürün söz konusu olduğunda ve genel
                    olarak ürün kullanıldığında ya da kullanılmamış olsa dahi ambalajından çıkarıldığında Üye cayma
                    hakkını kullanamaz. Fikri eser olan ve kopyalanabilecek olan kitap vb. materyaller için iade söz
                    konusu değildir. İade hakları ile ilgili tüm hususlar Türkiye Cumhuriyeti Kanunları,
                    Yönetmelikleri vb. ile belirlenen koşullar dahilinde değerlendirilmektedir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.22. </span></b>
                  <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> Şayet site üzerinde
                    böylesi bir uygulama mevcut ise,
                    üyelerin satın aldıkları ürünler Minticity tarafından seçilen bir kargo firmasıyla gönderilecektir.
                    Kargo paketi üye tarafından kontrol edilip teslim alınmalı,
                    herhangi bir eksiklik ve/veya hasar vb. olumsuz bir durum varsa bu,
                    kargo personeli ile birlikte tutanak altına alınmalıdır. Aksi takdirde;
                    kargonun üyeye teslimi ile birlikte ürün üyenin kabul edilecek ve bununla birlikte tüm sorumluluk
                    kendisine ait olacaktır. Kargo ücreti ile ilgili hususlar online alışveriş sırasında üyeye
                    bildirileceği şekildedir. Minticity kısmen veya tamamen kargo ücretini alıp almamakta
                    serbesttir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <b> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> 3.23.</span></b><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> Şayet site üzerinde böylesi
                    bir uygulama mevcut ise,
                    Minticity,
                    üyenin satın aldığı tüm materyalleri sevkiyat tarihine kadar tedarik edememesi durumunda,
                    tedarik edemediği ürünün bedelini üyeye iade edecek ve diğer ürünleri gönderecektir. Üye kendisine
                    gönderilen ürünleri,
                    yine ürünlerle birlikte gönderilecek olan faturadan takip edebilir. O an için tedarik edilemeyen ürün
                    daha sonra bulunduğu takdirde,
                    üyeye bilgi verilecektir. Bu durumda üyenin talebi doğrultusunda işlem yapılacaktır.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"><b> <span
                      style="font-size: 13.5pt; font-family: Verdana,sans-serif; color: black"> 4. Diğer
                      Hususlar</span></b>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">Ek bilgi almak istediğiniz
                    konularda +90 232 445 10 08 numaralı DAS Akademie Müşteri Hizmetleri telefonumuzdan,
                  </span> <a style="color: blue; text-decoration: underline; text-underline: single"
                    href="mailto:info@das-akademie."> <span style="font-size: 9.0pt; font-family: Verdana,sans-serif">
                      info@das-akademie.</span></a><span class="MsoHyperlink"><span
                      style="font-size: 9.0pt; font-family: Verdana,sans-serif">de</span></span><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> eposta adresinden veya
                    www.minticity.com adresinden Minticity’ ye danışabilirsiniz.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white">
                  <span style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> Site üzerinde işlem yapan
                    kişinin 18 yaşından küçük olması durumunda,
                    kendisine önceden üyelik giriş bilgileri iletilmiş olan velisi tüm işlemlerden sorumlu olacaktır.
                    Minticity sadece öğrenci velileri ile bilgi paylaşımı yapmaktadır. Velisi bulunduğu öğrencinin sistemi
                    yalnız başına kullanmasını istemeyen veliler,
                    şifre vb. izin verilen giriş bilgilerini kendilerine özel olarak değiştirerek,
                    siteye kendileri dışında girişi imkansız kılabilirler.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"><b> <span
                      style="font-size: 13.5pt; font-family: Verdana,sans-serif; color: black"> 5. Sözleşmenin Süresi ve
                      Feshi</span></b>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> İşbu sözleşme üyeye
                    bildirilen aktivasyon tarihinden itibaren,
                    9 aylık kullanım süresinin dolmasına (her halukarda en fazla 1 yıl) veya Minticity tarafından
                    üyeliğinin iptal edilmesine kadar yürürlükte kalacaktır. Minticity üyenin üyelik sözleşmesinin
                    herhangi bir hükmünü ihlal etmesi durumunda üyenin üyeliğini iptal ederek sözleşmeyi tek taraflı
                    olarak feshedebilecektir.</span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="text-align: justify; line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"><b> <span
                      style="font-size: 13.5pt; font-family: Verdana,sans-serif; color: black"> 6. İhtilafların
                      Halli</span></b>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"><span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> İşbu sözleşmeye ilişkin
                    ihtilaflarda İZMİR Mahkemeleri ve İcra Daireleri yetkilidir.</span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 12.0pt; font-family: Arial,sans-serif; color: black">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"><b> <span
                      style="font-size: 13.5pt; font-family: Verdana,sans-serif; color: black"> 7. Yürürlük</span></b>
                </p>
                <p class="MsoNormal" style="line-height: normal; margin-bottom: .0001pt; background: white"> <span
                    style="font-size: 9.0pt; font-family: Verdana,sans-serif; color: black"> Üyenin,
                    üyelik kaydı yapması üyenin üyelik sözleşmesinde yer alan tüm maddeleri okuduğu ve üyelik
                    sözleşmesinde yer alan maddeleri kabul ettiği anlamına gelir. İşbu Sözleşme üyenin üye olması anında
                    akdedilmiş ve karşılıklı olarak yürürlüğe girmiştir.</span>
                </p>
                <p class="MsoNormal">&nbsp;</p>
                <p class="MsoNormal" style="text-align: center; line-height: normal" align="center">
                  <b><i><span style="font-family: Verdana,sans-serif"> <a
                          style="color: blue; text-decoration: underline; text-underline: single"
                          href="http://www.minticity.com"> www.minticity.com</a></span></i></b>
                </p>
                <p class="MsoNormal" style="text-align: center; line-height: normal" align="center">
                  <b><span style="font-family: Verdana,sans-serif">Site Gizlilik Bildirimi (Privacy Policy)</span></b>
                </p>
                <p class="MsoNormal" style="text-align: center; line-height: normal" align="center">
                  <b><span style="font-family: Verdana,sans-serif">&nbsp;
                    </span></b>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">minticity.com “Minticity”,
                    gizliliğinizi korumak konusunda kararlıdır. Bu gizlilik bildirimi,
                    minticity.com site ve sitelerinin (“Site”) veri toplama ve kullanma uygulamalarını açıklar. Bu siteye
                    erişmeniz bu gizlilik bildiriminde tanımlanan,
                    bilgi toplama ve kullanma uygulamalarını kabul ediyor olduğunuzu gösterir.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Bu bildirimde ve aksi belirtilmedikçe,
                    Site üzerinde sağladığınız kişisel bilgiler izniniz olmaksızın minticity.com ve denetlediği yan
                    kuruluşları ve bağlı kuruluşları dışında paylaşılmayacaktır&nbsp;
                    (minticity.com bir Özel Alman Dil Hizmetleri Eğitimi Tercüme Ticaret Limited Şirketi
                    uygulamasıdır).</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <b><i>
                      <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Kişisel Bilgilerinizin
                        Toplanması</span></i></b>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <b><i>
                      <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                      </span></i></b>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Bu bilgileri,
                    minticity.com’ a kayıt olurken ya da minticity.com ürünleri ve hizmetleri hakkında bilgi alma,
                    yarışmalara katılma,
                    e-posta haber bültenleri sipariş etme,
                    erişim sınırlaması olan özel site veya hizmetlere katılma,
                    bir etkinlik veya eğitime kaydolma,
                    site üzerinden herhangi bir satın alma işleminde bulunma gibi talep ettiğiniz bir işlemi
                    gerçekleştirmenize veya size hizmet sağlamak için sizinle iletişim kurmamıza izin veren,
                    sizi kişi olarak tanıtan bilgilere (kişisel bilgiler) gerek duyduğumuz zaman sizden isteriz.
                    Topladığımız kişisel bilgiler arasında adınız,
                    unvanınız,
                    şirket veya kuruluşunuzun adı,
                    iş e-posta adresiniz,
                    iş telefonunuz,
                    iş veya ev adresiniz ve iş tanımınızla ile ilgili bilgiler olabilir.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Site,
                    ziyaretleriniz hakkında,
                    Siteye erişmek için kullandığınız Internet servis sağlayıcısının adı ve Internet Protokol (IP) adresi,
                    Siteye erişme tarihi ve saatiniz,
                    Sitede bulunduğunuz sırada eriştiğiniz sayfalar ve sitemize doğrudan bağlanmanızı sağlayan Web
                    sitesinin Internet adresi gibi birtakım bilgiler toplayabilir. Bu bilgiler sitenin iyileştirilmesi,
                    eğilimlerin analiz edilmesi ve Sitenin yönetilmesi için kullanılır.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Site kullanımı,
                    üyeleri,
                    ürünleri ve ilgili teknolojiler hakkındaki bilgileri ve haberleri paylaşmak üzere minticity.com
                    çalışanları,
                    uzmanları ve sizinle eş düzey kullanıcılarla iletişime girme olanakları sağlar. minticity.com,
                    e-posta adresinizin veya diğer kişisel bilgilerinizin başkaları tarafından toplanmasını,
                    uygunsuz veya zararlı amaçlar için kullanılmasını önlemek için,
                    gerçek e-posta adresinizi veya diğer kişisel bilgilerinizi,
                    yorumlar veya diğer genel forumlarda açıklamamaya dikkat etmeniz konusunda sizi uyarır.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <b><i>
                      <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Kişisel Bilgilerinizin
                        Kullanımı</span></i></b>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Sitede toplanan kişisel bilgiler,
                    Sitenin işletilmesi ve istediğiniz veya yetkilendirdiğiniz hizmetlerin sağlanması ya da işlemlerin
                    yerine getirilmesi için kullanılır.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">minticity.com bu kullanımları
                    desteklemek üzere,
                    müşterilerine daha etkili hizmet sunmak,
                    Siteyi ve diğer ilgili minticity.com ürünlerini veya hizmetlerini iyileştirmek ve aynı bilgileri
                    tekrar tekrar girme gereğini ortadan kaldırarak Sitenin kullanımını daha kolay hale getirmek veya
                    Siteyi özel tercihlerinize ve ilgi alanlarınıza göre özelleştirmek için kişisel bilgileri
                    kullanabilir. minticity.com ile ilişkilerinizin dengeli sürmesini sağlamak için,
                    minticity.com tarafından kullanılan bilgiler diğer minticity.com hizmetleri tarafından toplanan
                    bilgilerle birleştirilebilir.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Kişisel bilgilerinizi,
                    kritik güncelleştirmeleri ve bildirimleri de içerecek şekilde,
                    kullanmakta olduğunuz ürün veya hizmetler hakkında önemli bilgiler sağlamak için kullanabiliriz.
                    Ayrıca,
                    size diğer minticity.com ürünleri ve hizmetleri hakkında çeşitli yollarla bilgiler gönderebilir
                    ve/veya kendi ürünleri ve hizmetleri hakkında bilgi gönderebilmeleri için bu bilgileri diğer
                    minticity.com ortaklarıyla paylaşabiliriz.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Araştırma amacıyla,
                    site ziyaretleriyle ilgili verileri anonim demografik bilgilerle birleştiririz ve bu bilgileri daha
                    yararlı içerik sağlamak üzere toplu bir şekilde kullanabiliriz. minticity.com sitesinin giriş
                    sınırlaması olan kimi bölümlerinde,
                    kişiselleştirilmiş içerik sağlamak için,
                    sizden onay alarak site ziyaret verilerini kişisel bilgilerinizle birleştirebiliriz.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Site üyelik ve satın alma sözleşmesi
                    ile e-postalarını almayı kabul ettiğiniz minticity.com,
                    tıklattığınız e-postaları izlemek için özelleştirilmiş bağlantılar veya benzeri teknolojiler
                    kullanabilir. Size daha uygun e-postalar veya satış bilgileri gönderebilmek için bu bilgileri kişisel
                    bilgilerinizle ilişkilendirebiliriz. Her e-posta,
                    bu tür iletilerin gelmesini durdurmanıza olanak veren,
                    abonelik iptal bağlantıları içerir.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif"><br> Sitemizdeki kayıt formları,
                    anketler ve yarışmalar;
                    iletişim bilgilerinizi (adınız,
                    soyadınız,
                    email adresiniz,
                    telefon numaralarınız,
                    posta adresiniz,
                    vb.) ve kişisel bilgilerinizi (yaşınız,
                    mesleğiniz,
                    vb.) vermenizi talep edebilir. Minticity.com web sitelerini ziyaret eden kullanıcıların bilgileri
                    (ziyaret süresi,
                    zamanı,
                    görüntülenen sayfalar) onlara daha iyi hizmet edebilmek amacı ile takip edilmektedir. Elde edilen
                    bilgiler,
                    gizlilik prensiplerine bağlı kalmak kaydıyla,
                    içerik bölümümüzü zenginleştirmek ve iyileştirmek amacı ile anket,
                    reklam vb. konularda kullanılabilir. Bu işlemler sonucunda verdiğiniz iletişim bilgileri üzerinden
                    sizinle iletişime geçilmesini kabul etmiş olursunuz. minticity.com’ dan tarafınıza gönderilecek
                    e-Bülten ve/veya bilgilendirme e-maillerini almak istememeniz durumunda,
                    e-mail içeriğinde yer alan listeden çıkış isteği bağlantısına tıklanarak engellenebilir.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Minticity.com,
                    kişisel bilgilerinizi yasal bir zorunluluk olarak istendiğinde veya (a) yasal gereklere uygun hareket
                    etmek veya Minticity.com ya da Siteye tebliğ edilen yasal işlemlere uymak;
                    (b) Minticity.com ve Web sitesi ailemizin haklarını ve mülkiyetini korumak ve savunmak;
                    (c) Minticity.com çalışanlarının veya aracılarının,
                    Minticity.com ürünü kullananların veya kamu güvenliği açısından acil durumlarda harekete geçmek için
                    gerekli olduğuna iyi niyetle kanaat getirdiği hallerde açıklayabilir.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <b><i>
                      <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Kişisel Bilgilerinize
                        Erişim</span></i></b>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <b><i>
                      <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                      </span></i></b>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Bu Sitede sağladığınız kişisel bilgiler
                    ve bağlantı tercihlerinizi kendi sayfanızda inceleyebilir ve düzenleyebilirsiniz. Kişisel bilgileriniz
                    görüntülenmeden önce,
                    kullanıcı adı ve parolanızı girmeniz istenir.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">minticity.com üzerinde sunulan kimi
                    hizmetler Profil Merkezi' nden erişilemeyen bilgiler
                    toplayabilir. Ancak,
                    bu türden durumlarda kişisel bilgilerinize,
                    bu bildirimin sonunda açıklanan şekilde minticity.com ile bağlantı kurarak veya söz konusu hizmet
                    tarafından açıklanan başka yollarla erişebilirsiniz.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <b><i>
                      <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                      </span></i></b>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <b><i>
                      <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Kişisel Bilgilerinizin
                        Güvenliği</span></i></b>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">minticity.com,
                    kişisel bilgilerinizin güvenliğini korumayı ilke edinmiştir. Kişisel bilgilerinizi yetkisiz erişime,
                    kullanıma veya açığa çıkmaya karşı korumak için çok çeşitli güvenlik teknolojileri ve yordamları
                    kullanırız. Örneğin,
                    sağladığınız bilgileri kontrol altındaki tesislerde bulunan ve sınırlı erişimi olan bilgisayar
                    sunucularında depolarız.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Kredi kartı ile işlem yapıldığı
                    takdirde;
                    www.minticity.com sitesine girilen bilgilerin ve işlemlerin güvenliği için gerekli önlemler,
                    bilgi ve işlemin mahiyetine Minticity ve/veya ilgili kart kuruluşlarınca sistem ve internet
                    altyapısında alınmıştır. Tüm kredi kartı işlemleri ve onayları tarafımızdan bağımsız olarak ilgili
                    banka ve benzeri kart kuruluşlarınca online olarak üye ile ilgili kuruluş arasında
                    gerçekleştirilmektedir (Kredi kartı şifresi gibi bilgiler Minticity tarafından görülmez ve
                    kaydedilmez). Üyelerin siteye üyelik,
                    ürün/hizmet satın alma ve bilgi güncelleme amaçlı girdikleri bilgiler,
                    özellikle kredi kartı ve banka kartlarına ait gizli bilgiler diğer internet kullanıcıları tarafından
                    görüntülenemez.</span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                  </span>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <b><i>
                      <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Bu Gizlilik Bildiriminde
                        Yapılabilecek Değişiklikler</span></i></b>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <b><i>
                      <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">&nbsp;
                      </span></i></b>
                </p>
                <p class="MsoNormal"
                  style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:justify;line-height:normal">
                  <span style="font-size: 10.0pt; font-family: Verdana,sans-serif">Bu gizlilik bildirimini zaman zaman
                    güncelleştirebiliriz. Hizmeti kullanmanız bu gizlilik bildirimini ve yapılabilecek güncelleştirmeleri
                    kabul ettiğiniz anlamına gelir.</span>
                </p>
                <p class="MsoNormal" style="text-align:justify"> <span
                    style="font-size: 10.0pt; line-height: 115%; font-family: Verdana,sans-serif"> &nbsp;
                  </span>
                </p>
                <p></p>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-info text-white"
                @click="modal('student', 'studentActivationAgreement', 'hide')">Schließen
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActivationForm from './ActivationForm';

export default {
  components: { ActivationForm },
  data() {
    return {
      searchTxt: null,
      showMessage,
      section: '',
      school: {
        list: schoolList,
        selected: '',
        subSelected: '',
        classLevel: ''
      },
      schoolList,
      student: {
        values: StudentActivationFormValues,
        form: new Form({
          id: null,
          classroom: '',
          personal_number: '',
          code: '',
          email: '',
          veli_email: '',
          phone: '',
          iys: 0,
          password: '',
          password_confirmation: '',
          agreement: false,
          kvkk: false,
          iysModal: false
        })
      },
      studentPrefix: {
        values: StudentActivationFormValues,
        form: new Form({
          user_id: -1,
          code: '',
          email: '',
          password: '',
          password_confirmation: '',
          agreement: false
        })
      },
      parent: {
        values: ParentActivationFormValues,
        form: new Form({
          personal_number: '',
          name_surname: '',
          email: '',
          password: '',
          password_confirmation: '',
          agreement: false
        })
      },
      prevSection: [],
      globSearch: '',
      child: null,
      schoolnumber: null,
      selectUser: null,
      error: null
    };
  },
  computed: {
    getSchoolChildren() {
      return this.school.selected.children.filter(ch => ch.name.toLowerCase().indexOf(this.globSearch.toLowerCase()) > -1);
    }
  },
  methods: {
    filterSchool() {
      let srcTxt = this.searchTxt.toLowerCase();
      this.school.list = this.schoolList.filter(function (school) {
        return school.name.toLowerCase().indexOf(srcTxt) > -1;
      });
    },
    filterCancel() {
      this.searchTxt = null;
      this.school.list = this.schoolList;
    },
    submitStudentForm() {
      let id = null;
      let classroom = '';

      if (this.school.selected.children) {

        if (this.school.subSelected === '') {
          return Swal.fire({
            html: 'Lütfen şube seçiniz',
            type: 'error'
          });
        }

        id = this.school.subSelected.id;

        if (this.school.subSelected.personal_number_type !== 'tc' && this.school.classLevel === '') {
          return Swal.fire({
            html: 'Lütfen sınıf seviyesi seçiniz',
            type: 'error'
          });
        }

      } else {

        if (this.school.selected.personal_number_type !== 'tc' && this.school.classLevel === '') {
          return Swal.fire({
            html: 'Lütfen sınıf seviyesi seçiniz',
            type: 'error'
          });
        }

        id = this.school.selected.id;

      }

      classroom = this.school.classLevel;

      this.student.form.id = id;
      this.student.form.classroom = classroom;

      if (this.student.form.agreement) {
        return this.student.form.post(url).then(response => {
          window.axios.defaults.headers.common['X-CSRF-TOKEN'] = response.token;
          Swal.fire({
            html: response.message,
            type: 'success'
          });
        })/*.catch(error => {
                        window.axios.defaults.headers.common['X-CSRF-TOKEN'] = error.response.data.token;
                    })*/;
      }
      if (!this.student.form.agreement) {
        Swal.fire({
          type: 'error',
          title: 'Üyelik sözleşmesini kabul etmelisiniz!',
          confirmButtonText: 'Tamam!'
        });
      }
    },
    submitStudentFormPrefix() {
      if (this.studentPrefix.form.agreement) {
        return this.studentPrefix.form.post(urlprefix, {
          user_id: this.selectUser.id
        }).then(response => {
          window.axios.defaults.headers.common['X-CSRF-TOKEN'] = response.token;
          Swal.fire({
            html: response.message,
            type: 'success'
          });
        });
      }
      Swal.fire({
        type: 'error',
        title: 'Üyelik sözleşmesini kabul etmelisiniz!',
        confirmButtonText: 'Tamam!'
      });
    },
    backToPreviousSection() {
      this.section = this.prevSection.pop();
      if (this.section === 'parentSection') {
        this.section = this.prevSection.pop();
      }
      this.checkSection();
    },
    setSection(section) {
      this.prevSection.push(this.section);
      this.section = section;
      this.checkSection();
    },
    checkSection() {
      if (this.section === 'parentSection') {
        Swal.fire({
          title: 'Lütfen Dikkat!',
          text: 'Veli ekranı oluşturabilmek için ilk olarak öğrenci aktivasyonu yapılması gerekmektedir?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#dd3333',
          confirmButtonText: 'Evet Yapıldı.',
          cancelButtonText: 'Hayır Yapılmadı.'
        }).then((result) => {
          if (result.value) {
            this.setSection('parentCreate');
          } else {
            this.setSection('schoolSelection');
          }
        });
      }
    },
    sendToLink(link) {
      window.location.href = link;
    },
    modal(variable, key, fn) {
      $(`#${key}`).modal(fn);
      if (fn === 'hide' && !this[variable].form.agreement && key === 'studentActivationAgreement') {
        this[variable].form.agreement = true;
      }
      if (fn === 'hide' && !this[variable].form.kvkk && key === 'studentActivationKvkk') {
        this[variable].form.kvkk = true;
      }
      if (fn === 'hide' && !this[variable].form.iysModal && key === 'studentActivationIYS') {
        this[variable].form.iysModal = true;
      }
    },
    selectSchool(school) {
      this.school.selected = school;
      this.school.subSelected = '';
      /*if (school.children) {
          this.child = null;
          this.schoolnumber = null;
          this.selectUser = null;
          this.setSection('selectBranch');
          return;
      }*/
      if (school.personal_number_type && school.personal_number_type === 'school_number') {
        this.student.values = { ...StudentActivationFormValuesSchoolNumber };
      } else {
        this.student.values = { ...StudentActivationFormValues };
      }
      this.setSection('studentActivation');
    },
    selectChildrenSchool(child) {
      this.child = child;
    },
    checkSchoolNumber() {
      this.error = null;
      axios.post(checkurl, {
        number: this.schoolnumber,
        school_id: this.child.id
      }).then((response) => {
        if (response.data.error) {
          this.error = response.data.error;
        } else {
          this.selectUser = response.data;
        }
      })
    }
  },
  mounted() {
    this.section = 'schoolSelection';
    $('body').removeClass('loading');
  },
  watch: {
    schoolnumber: {
      handler: function () {
        this.error = null;
      },
      deep: true
    },
    'school.selected': {
      handler: function () {
        this.student.values.personalNumber = this.school.selected.personal_number_type === 'school_number' ?
          StudentActivationFormValuesSchoolNumber.personalNumber : StudentActivationFormValues.personalNumber;
        this.school.subSelected = '';
      },
      deep: true,
    },
    'school.subSelected': {
      handler: function () {
        this.school.classLevel = '';
        if (this.school.subSelected !== '') {
          this.student.values.personalNumber = this.school.subSelected.personal_number_type === 'tc' ?
            StudentActivationFormValues.personalNumber : StudentActivationFormValuesSchoolNumber.personalNumber;
          this.$forceUpdate();
        }
        this.$forceUpdate();
      },
      deep: true,
    }
  }
};
</script>

<style lang="scss" scoped>
$primary: rgb(182, 157, 230);
$gradient: #38c172;

.school-logo-for-selection {
  background: url(https://tr.minticity.com/images/account/logo-frame.png) no-repeat center center / contain;
}

.content {
  padding-top: 4rem !important;
  height: 100vh;
}

.block {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}

.img-fluid {
  max-width: 15rem;
}

.br25 {
  border-radius: 2.5rem;
}

.br1 {
  border-radius: 1rem;
}

p.MsoNormal {
  mso-style-parent: "";
  margin-top: 0;
  margin-right: 0;
  margin-bottom: 10pt;
  margin-left: 0;
  line-height: 115%;
  font-size: 11.0pt;
  font-family: "Calibri", "sans-serif";
}

.selection {
  cursor: pointer;
}

.activation-form {
  .block {
    position: relative;
    clear: both;
    margin: 0 0 25px;

    span {
      font-weight: bold;
      letter-spacing: 1px;
      font-size: 15px;
    }

    label {
      width: 100px;
      height: 50px;
      box-sizing: border-box;
      border: 3px solid;
      border-radius: 100px;
      position: relative;
      cursor: pointer;
      transition: .3s ease;
    }

    input {
      display: none;
    }

    input[type=checkbox]:checked+label {
      background: #55e868;
    }

    input[type=checkbox]:checked+label:before {
      left: 50px;
    }

    label:before {
      transition: .3s ease;
      content: '';
      width: 40px;
      height: 40px;
      position: absolute;
      background: white;
      left: 2px;
      top: 2px;
      box-sizing: border-box;
      border: 3px solid;
      color: black;
      border-radius: 100px;
    }
  }

  button:disabled {
    cursor: not-allowed;
  }

  .floating-label {
    background-color: #FFFFFF;
    position: relative;
    width: 100%;
    margin-bottom: 10px;

    input {
      font-size: 16px;
      padding: 20px 0;
      padding-left: 16px;
      height: 56px;
      border: none;
      border-bottom: solid 1px $gradient;
      background: #FFFFFF;
      box-sizing: border-box;
      transition: all .3s linear;
      color: #000000;
      width: 100%;
      font-weight: 400;
      -webkit-appearance: none;

      &:focus {
        border-bottom: solid 4px $gradient;
        outline: 0;
        box-shadow: 0 2px 6px -8px rgba($primary, .45);
      }
    }

    label {
      position: absolute;
      top: calc(50% - 10px);
      left: 0;
      opacity: 0;
      transition: all .3s ease;
    }

    input:not(:placeholder-shown) {
      padding: 28px 0 12px 16px;
    }

    input:not(:placeholder-shown)+label {
      transform: translate(-1px, -15px);
      opacity: .7;
    }

    .icon {
      cursor: pointer;
      position: absolute;
      top: 0;
      right: 10px;
      height: 56px;
      width: 44px;
      display: flex;

      span {
        font-size: 1.75rem;
      }
    }
  }

  .did-floating-label-content {
    position: relative;
    margin-bottom: 10px;
  }

  .did-floating-label {
    color: #1e4c82;
    font-size: 16px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 15px;
    top: 11px;
    padding: 0 5px;
    background: #fff;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
  }

  .did-floating-input,
  .did-floating-select {
    font-size: 16px;
    display: block;
    width: 100%;
    height: 45px;
    padding: 0 20px;
    background: #fff;
    color: #323840;
    border: 1px solid #3D85D8;
    border-radius: 4px;
    box-sizing: border-box;

    &:focus {
      outline: none;

      ~.did-floating-label {
        top: -8px;
        font-size: 13px;
      }
    }
  }

  select.did-floating-select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  select.did-floating-select::-ms-expand {
    display: none;
  }

  .did-floating-input:not(:placeholder-shown)~.did-floating-label {
    top: -8px;
    font-size: 13px;
  }

  .did-floating-select:not([value=""]):valid~.did-floating-label {
    top: -8px;
    font-size: 13px;
  }

  .did-floating-select[value=""]:focus~.did-floating-label {
    top: 11px;
    font-size: 13px;
  }

  .did-floating-select:not([multiple]):not([size]) {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='6' viewBox='0 0 8 6'%3E%3Cpath id='Path_1' data-name='Path 1' d='M371,294l4,6,4-6Z' transform='translate(-371 -294)' fill='%23003d71'/%3E%3C/svg%3E%0A");
    background-position: right 15px top 50%;
    background-repeat: no-repeat;
  }

  .did-error-input {

    .did-floating-input,
    .did-floating-select {
      border: 2px solid #9d3b3b;
      color: #9d3b3b;
    }

    .did-floating-label {
      font-weight: 600;
      color: #9d3b3b;
    }

    .did-floating-select:not([multiple]):not([size]) {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='6' viewBox='0 0 8 6'%3E%3Cpath id='Path_1' data-name='Path 1' d='M371,294l4,6,4-6Z' transform='translate(-371 -294)' fill='%239d3b3b'/%3E%3C/svg%3E%0A");
    }
  }

  .toggle-btn {
    width: 80px;
    height: 40px;
    margin: 10px;
    border-radius: 50px;
    display: inline-block;
    position: relative;
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAyklEQVQ4T42TaxHCQAyENw5wAhLACVUAUkABOCkSwEkdhNmbpHNckzv689L98toIAKjqGcAFwElEFr5ln6ruAMwA7iLyFBM/TPDuQSrxwf6fCKBoX2UMIYGYkg8BLOnVg2RiAEexGaQQq4w9e9klcxGLLAUwgDAcihlYAR1IvZA1sz/+AAaQjXhTQQVoe2Yo3E7UQiT2ijeQdojRtClOfVKvMVyVpU594kZK9zzySWTlcNqZY9tjCsUds00+A57z1e35xzlzJjee8xf0HYp+cOZQUQAAAABJRU5ErkJggg==') no-repeat 50px center #e74c3c;
    cursor: pointer;
    -webkit-transition: background-color .40s ease-in-out;
    -moz-transition: background-color .40s ease-in-out;
    -o-transition: background-color .40s ease-in-out;
    transition: background-color .40s ease-in-out;

    &.active {
      background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAmUlEQVQ4T6WT0RWDMAhFeZs4ipu0mawZpaO4yevBc6hUIWLNd+4NeQDk5sE/PMkZwFvZywKSTxF5iUgH0C4JHGyF97IggFVSqyCFga0CvQSg70Mdwd8QSSr4sGBMcgavAgdvwQCtApvA2uKr1x7Pu++06ItrF5LXPB/CP4M0kKTwYRIDyRAOR9lJTuF0F0hOAJbKopVHOZN9ACS0UgowIx8ZAAAAAElFTkSuQmCC') no-repeat 10px center #2ecc71;

      .round-btn {
        left: 45px;
      }
    }

    .round-btn {
      width: 30px;
      height: 30px;
      background-color: #fff;
      border-radius: 50%;
      display: inline-block;
      position: absolute;
      left: 5px;
      top: 50%;
      margin-top: -15px;
      -webkit-transition: all .30s ease-in-out;
      -moz-transition: all .30s ease-in-out;
      -o-transition: all .30s ease-in-out;
      transition: all .30s ease-in-out;
    }

    .cb-value {
      position: absolute;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      z-index: 9;
      cursor: pointer;
      -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    }
  }
}

.floating-button {
  position: absolute;
  left: 86%;
  top: 1.3%;
  z-index: 1049 !important;
}

.card-img {
  padding: 1rem 0;
}

.card {
  &>.card-header {

    h2,
    h5 {
      margin: 0;
    }
  }
}

.loginImage {
  max-width: 8%;
  padding-left: .5rem;
}

.messageContainer {
  background-color: #fff !important;
  border: solid #ffae00 15px;
  border-radius: 35px;
}

.messageArea {
  padding: 15px;
}

.attentionImg {
  width: 250px !important;
}
</style>
